import { Component, Output, Input, EventEmitter, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms'
import { AddressDialogComponent } from '../address-dialog/address-dialog.component';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { loadModules } from 'esri-loader';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { GoogleMapComponent } from '../google-map/google-map.component';
import { EsriMapComponent } from '../esri-map/esri-map.component';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

type ContactProtectedField = 'firstname' | 'lastname' | 'emailaddress' | 'phonenumber1'

@Component({
  selector: 'app-address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.scss']
})
export class AddressDetailsComponent implements OnChanges {

  contactSearchForm: FormGroup;
  answerSearchForm: FormGroup;
  incidentSearchForm: FormGroup;


  @ViewChild('confirmationModal') confirmationModal!: ElementRef;
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  @ViewChild(NgbDropdown) ngbDropdown: NgbDropdown;

  triggerDropdown() {
    // alert(this.ngbDropdown.isOpen())
    if (!this.ngbDropdown.isOpen())
      this.ngbDropdown.toggle(); // Opens or closes the dropdown
  }

  @ViewChild(GoogleMapComponent) GoogleMapComponent: GoogleMapComponent;
  @ViewChild(EsriMapComponent) EsriMapComponent: EsriMapComponent;

  // class1Active: boolean = true;
  // class2Active: boolean = false;
  // Associated: boolean = false;


  tcontainer = {
    'height': ($(window).height() - $('.layout-navbar').height() - 320) + 'px',
    'overflow': 'hidden',
    'overflow-y': 'auto'
  };
  tcontainer1 = {
    'height': ($(window).height() - $('.layout-navbar').height() - 500) + 'px',
    'overflow': 'hidden',
    'overflow-y': 'auto'
  };
  // toggleClass1() {
  //   this.class1Active = !this.class1Active;
  // }

  // toggleClass2() {
  //   this.class2Active = !this.class2Active;
  // }

  @Input() serviceTypeInfo: any;
  @Input() componentData: any;
  @Output() componentSelection = new EventEmitter<any>();
  // @Output() activeSRValues: EventEmitter<any> = new EventEmitter();

  data: any;

  // receiveData(data: any) {
  //   if(data.address_t == "SINGLE_LINE"){
  //     this.addressDetailsForm.get(['locationDtls','addresstype'])?.setValue("1362");
  //     this.addressDetailsForm.get(['locationDtls','addressline2'])?.setValue("");
  //   }else{
  //     this.addressDetailsForm.get(['locationDtls','addresstype'])?.setValue("1363");
  //     this.addressDetailsForm.get(['locationDtls','addressline2'])?.setValue(data.address2);
  //   }
  //   this.addressDetailsForm.get(['locationDtls','addressline1'])?.setValue(data.address);
  //   this.addressDetailsForm.get(['locationDtls','city'])?.setValue(data.msr_city);
  //   this.addressDetailsForm.get(['locationDtls','state'])?.setValue(data.msr_state);
  //   this.addressDetailsForm.get(['locationDtls','postalcode'])?.setValue(data.msr_zip);
  //   this.addressDetailsForm.get(['locationDtls','longitude'])?.setValue(data.msr_lng);
  //   this.addressDetailsForm.get(['locationDtls','latitude'])?.setValue(data.msr_lat);
  //   this.addressDetailsForm.get(['locationDtls','withinlimits'])?.setValue('191');
  //   this.addressDetailsForm.get(['locationDtls','jurisdiction'])?.setValue('193');
  //   this.addressDetailsForm.get(['locationDtls','zoning'])?.setValue("Commercial");
  //   this.addressDetailsForm.get(['locationDtls','recycleweek'])?.setValue('1360');
  //   this.addressDetailsForm.get(['locationDtls','collectionday'])?.setValue('');
  //   this.addressDetailsForm.get(['locationDtls','parcelnumber'])?.setValue('02-12-02-432-001.000-074');
  // }

  navigateToGarbageInfo()
  {

    console.log(this.fetchaddressdetails)
    console.log(this.assignentireaddress)
    console.log(this.garbagecollectionday)
    console.log(this.fetchaddressdetails?.returned_address)
    var locationdata = this.agentscriptservice.fetchData(this.tab_title, 'locationdata');
    console.log(locationdata)
    if(this.garbagecollectionday)
    {
      // console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)

      if (locationdata.addressline1 !== undefined && locationdata.addresstype === "1362") {
        // Check if postalcode is present
        const postalCodePart = locationdata.postalcode ? `, ${locationdata.postalcode}` : ''; // Include only if postalcode is not empty

        const baseUrl = `https://test.acimap.us/portal/apps/instant/lookup/index.html?appid=67243d9c7276441aa1a77300a151ab10&find=${locationdata.addressline1}, Fort Wayne, IN${postalCodePart}, USA`;

        window.open(baseUrl, '_blank');
      }

      else if(locationdata.addresstype=="1363")
      {

        let addressline = this.addressDetailsForm?.get('locationDtls.addressline1')?.value +
        (this.addressDetailsForm.get('locationDtls.addressline2').value
          ? ' and ' + this.addressDetailsForm.get('locationDtls.addressline2').value
          : '');

      const addresstonavigate = addressline.replaceAll(' ', '%2520').toLowerCase();

      // Get mailing zip and check if it's empty
      const mailingZip = locationdata.postalcode;
      const mailingZipPart = mailingZip ? `, ${mailingZip}` : ''; // Include only if mailingZip is not empty

      const baseUrl = `https://test.acimap.us/portal/apps/instant/lookup/index.html?appid=67243d9c7276441aa1a77300a151ab10&find=${addresstonavigate}, Fort Wayne, IN${mailingZipPart}, USA`;

      window.open(baseUrl, '_blank');

      }
      // else{

      //   // var streetAddress = item.split(',')[0].trim();
      //   this.assignentireaddress=this.assignentireaddress.split(',')[0].trim();
      //   const baseUrl = 'https://test.acimap.us/portal/apps/instant/lookup/index.html?appid=67243d9c7276441aa1a77300a151ab10&find='+this.assignentireaddress+', '+'Fort Wayne, '+'IN'+', USA';
      //   // window.location.href = 'https://test.acimap.us/portal/apps/instant/lookup/index.html?appid=67243d9c7276441aa1a77300a151ab10&find=200%2520e%2520berry%2520st'
      //   window.open(baseUrl, '_blank');
      // }

    }

  }

  nearbyIncidents: any;
  alertIncidents: any
  loadMap_button = true;
  receiveData(data: any) {
    this.loadMap_button = false;
    console.log(data)
    console.log(this.garbagecollectionday)
    if (data.msr_addresstype && data.msr_addresstype.includes("Intersection")) {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363")

      var fields = data.msr_serviceaddress.split('&');
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(fields[0])
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(fields[1])
      // 200 E Berry St, Fort Wayne, IN, 46802, USA
      this.garbagecollectionday=data.msr_serviceaddress;
      this.assignentireaddress = fields[0] + " & " + fields[1] + ", Fort Wayne, IN, " + data.msr_zip + ", USA"
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('Fort Wayne')
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")
    }
    else {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362")
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(data.msr_serviceaddress)
      this.garbagecollectionday=data.msr_serviceaddress;
      if(data.msr_serviceaddress!='')
        {
          this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetails', 0)
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

          this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('FORT WAYNE')
          this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue('IN')
        }
      // this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(data.msr_city)
      // this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(data.msr_state)

      // this.addressDetailsForm.get(['locationDtls','addressline2'])?.setValue(data.msr_)
    }
    // this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(data.msr_zip)
    // this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(data.msr_lng)
    // this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(data.msr_lat)
    // this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(data.msr_withinlimits)
    // this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(data.msr_jurisdiction)
    // this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue(data.msr_next_collection_day)
    // this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(data.msr_zoning)
    // this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(data.msr_recycleweek);
    // this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(data.msr_collectionday)
    // this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(data.msr_parcelnumber)

   this.custompropertyAssign();
    
   data.msr_zip ? (this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(data.msr_zip)) : (this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'postalcode']) as any).customProperty = 'disable')
   data.msr_lng ? (this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(data.msr_lng)) : (this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'longitude']) as any).customProperty = 'disable')
   data.msr_lat ? (this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(data.msr_lat)) : (this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'latitude']) as any).customProperty = 'disable')
   data.msr_withinlimits ? (this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(data.msr_withinlimits)) : (this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'withinlimits']) as any).customProperty = 'disable')
   data.msr_jurisdiction ? (this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(data.msr_jurisdiction)) : (this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'jurisdiction']) as any).customProperty = 'disable')
   data.msr_zoning ? (this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(data.msr_zoning)) : (this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'zoning']) as any).customProperty = 'disable')
   data.msr_recycleweek ? (this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(data.msr_recycleweek)): (this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'recycleweek']) as any).customProperty = 'disable');   
   data.msr_collectionday ? (this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(data.msr_collectionday)) : (this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'collectionday']) as any).customProperty = 'disable')
   data.msr_parcelnumber ? (this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(data.msr_parcelnumber)) : (this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(''),(this.addressDetailsForm.get(['locationDtls', 'parcelnumber']) as any).customProperty = 'disable')
   this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue(data.msr_next_collection_day)

   const locationdtls=this.addressDetailsForm.get(['locationDtls'])
   if (locationdtls instanceof FormGroup) {
    console.log(locationdtls.controls); 


    let result: any[] = [];
    Object.keys(locationdtls.controls).forEach(key => {
      const control = locationdtls.get(key);
  
        // Check for custom property
        if ((control as any).customProperty) {
          result.push({
            name: key, 
            value: control.value, 
            customProperty: (control as any).customProperty
          });
        }
      
    });
    // return result;
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', 0)
     this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', result)
   } else {
     console.error('locationDtls is not a FormGroup, it might be a FormControl');
   }
    // console.log(this.addressDetailsForm.get(['locationDtls']).controls)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))

    // this.tablocalstoragedata['locationdata']=this.addressDetailsForm.get(['locationDtls']).value
    // console.log(this.tablocalstoragedata)
    // this.standardservice.SavetolocalStorage('tabdata',{data:this.componentData,name:this.tab_title,tabdata:{'tabdata':this.tablocalstoragedata}})


    this.nearbyIncidents = data.msr_nearbyIncidents?.incidents
    this.alertIncidents = data.msr_alertIncidents?.incidents
    this.alertIncidents?.forEach((item: any) => {
      item.alert = false
    })
    // console.log(this.nearbyIncidents)
    console.log(this.alertIncidents)
    // this.formatDate(this.nearbyIncidents.created)

    this.loadMap_button = false;
    // this.agentscriptservice.updateOrInsertArray(this.tab_title,)

    // console.log(this.nearbyIncidents)
    if (this.addressDetailsForm.get(['contactDtls', 'mailingadd']).value.toLowerCase().includes(this.addressDetailsForm?.get('locationDtls.addressline1')?.value.toLowerCase())) {
      const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
      (issame as HTMLInputElement).checked = true;
    }
    else {
      const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
      (issame as HTMLInputElement).checked = false;

    }
  }


  togglealert(incident: any, boolean: any) {
    console.log(boolean)
    if (boolean) {
      this.alertIncidents.forEach((item: any) => {
        item.alert = false
      })

      const item = this.alertIncidents?.find(item => item.referenceNumber == incident);
      if (item) {
        console.log("item found")
        item.alert = true
      }

    }
    else {
      Swal.fire({
        title: 'Remove from Alert',
        html: "Are you Sure?",
        // type: 'success',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.alertIncidents.forEach((item: any) => {
            item.alert = false
          })
        }
      });
    }
  }

  addressDetailsForm: FormGroup;
  isLoginInfo: boolean = false;
  isAnonymous: boolean = true;
  exampleCheck1: boolean = false;
  isLocationSearch: boolean = true;
  marked: boolean = false;
  isGisVerified: boolean = false;
  searchLocation: any;
  //esri map
  mapCenter = [-85.1392, 41.0804];
  basemapType = 'satellite';
  mapZoomLevel = 11;
  mapLoadedEvent(status: boolean) {
    console.log('The map has loaded: ' + status);
    console.log("clicked")
  }
  tab_title: any;
  // componentData:any
  dataInfo: any;
  submitandcontinueitem: any = []

  withinlimits: any = []
  recycleweek: any = []
  jurisdiction: any = []
  collectionday: any = []
  zoning: any = []
  allPicklistArray:any = []

  picklist() {
    const picklistIDs = [37, 97, 32, 38, 33]; // Array of picklist IDs
    picklistIDs.forEach(picklistID => {
      this._standardUiService.getPicklistByID(picklistID).subscribe(data => {
        const picklistValues = [];
        for (let key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({
              "id": data[key].id,
              "value": data[key].valueen
            });
          }
        }
        if (picklistID == 37) {
          this.withinlimits.push(...picklistValues);
          this.allPicklistArray.push(...picklistValues)
          // console.log(this.casesubtypeVal)
        }
        else if (picklistID == 97) {
          this.recycleweek.push(...picklistValues);
          this.allPicklistArray.push(...picklistValues)
          // console.log(this.casetypeVal)
        }
        else if (picklistID == 32) {
          this.jurisdiction.push(...picklistValues);
          this.allPicklistArray.push(...picklistValues)
          // console.log(this.departmentVal)
        }
        else if (picklistID == 38) {
          this.collectionday.push(...picklistValues);
          this.allPicklistArray.push(...picklistValues)
          // console.log(this.servicerequest_source)
        }
        else if (picklistID == 33) {
          this.zoning.push(...picklistValues);
          this.allPicklistArray.push(...picklistValues)
          // console.log(this.addresstypeVal)
        }
          console.log(this.allPicklistArray)
      });
    });
  }

  clearcontactdetails() {
    if (this.sameAsServiceAddressCheckbox) {
      this.sameAsServiceAddressCheckbox.nativeElement.checked = false;
    }
    this.anonymouscontact=false;
    this.contactDetailFieldsReadOnly = true
    this.resetContactFieldEditConfirmations()
    this.addressDetailsForm.get('contactDtls')?.reset();
    this.addressDetailsForm.get(['contactDtls', 'fullcontact']).setValue('')
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', [])
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

  }
  isSelected(category: any): boolean {
    // this.searchPerformed=false;
    // console.log(category)
    return this.selectedCategories.includes(category);
  }
  showlayers() {
    this.EsriMapComponent.entirelayers = this.selectedCategories;
    this.EsriMapComponent.loadmapping()
  }
  selectedCategories: any = [];
  autoClose: NgbDropdown['autoClose'] = false;
  checkboxChanged(event: any, category: any) {
    const relatedCodesWater = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
    const relatedcodeSewer = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27]
    event.preventDefault();

    if (event.target.checked) {
      // If checkbox is checked, push the category name into the array
      this.selectedCategories.push(category);

    }
    else {
      // If checkbox is unchecked
      const index = this.selectedCategories.indexOf(category);
      if (index !== -1) {
        this.selectedCategories.splice(index, 1);
        // If it's code 2, also remove its related codes
        if (category === 2) {
          relatedCodesWater.forEach(code => {
            const relatedCategoryIndex = this.selectedCategories.indexOf(code);
            if (relatedCategoryIndex !== -1) {
              this.selectedCategories.splice(relatedCategoryIndex, 1);
            }
          });
        }
        if (category === 14) {
          relatedcodeSewer.forEach(code => {
            const relatedCategoryIndex = this.selectedCategories.indexOf(code);
            if (relatedCategoryIndex !== -1) {
              this.selectedCategories.splice(relatedCategoryIndex, 1);
            }
          });
        }
      }
    }


    console.log('Selected categories:', this.selectedCategories);
    this.showlayers();
    // You can now use this.selectedCategories array in your code to access the selected category names
  }

  // showlayers()
  // {
  //   this.EsriMapComponent.entirelayers=this.selectedCategories
  //   this.EsriMapComponent.loadmapping()
  // }

  showLayersDropdown: boolean = false; // Controls visibility of layers dropdown

  toggleLayersDropdown(event: Event) {
    event.preventDefault();
    this.showLayersDropdown = !this.showLayersDropdown; // Toggle the dropdown visibility
  }
  removeValidatorsFromLocationDtls() {

    const controls = [
      'addresstype', 'addressline1', 'city', 'state', 'latitude', 'longitude', 'postalcode', 'withinlimits', 'jurisdiction', 'zoning', 'recycleweek'

    ];

    controls.forEach(controlName => {
      const control = this.addressDetailsForm?.get(['locationDtls', controlName]);

      control?.clearValidators();

      control?.updateValueAndValidity();
    });
  }
  showconcataddresspopup: any
  openconcataddresspopup() {
    if (this.isContactDetailFieldsReadOnly()) {
      return
    }
    this.showconcataddresspopup = true
    const contactDtls = this.addressDetailsForm?.get('contactDtls') as FormGroup
    if (!contactDtls) return
    contactDtls.patchValue({
      street: '',
      city: '',
      postalcode: ''
    })
    this.concatstreet = ''
    this.concatpostal = ''
    const mailingadd = this.addressDetailsForm?.get(['contactDtls', 'mailingadd'])?.value
    if (!mailingadd || typeof mailingadd !== 'string') return
    const parts = mailingadd.trim().split(/\r?\n/).map((p: string) => p.trim()).filter(Boolean)
    const looksLikeState = (s: string) => /^[A-Za-z]{2}$/.test(s)
    const looksLikeCountry = (s: string) => /United States|\(US\)|\([A-Za-z]+\)$/i.test(s)
    const looksLikePostalCode = (s: string) => /\d/.test(s)
    if (parts.length >= 1 && parts[0]) {
      const p0 = parts[0]
      if (!looksLikeState(p0) && !looksLikeCountry(p0)) {
        contactDtls.patchValue({ street: p0 })
        this.concatstreet = p0
      }
    }
    if (parts.length >= 2 && parts[1]) {
      const cityState = parts[1]
      const tokens = cityState.split(/\s+/)
      const stateCandidate = tokens[tokens.length - 1]
      if (stateCandidate && looksLikeState(stateCandidate)) {
        contactDtls.patchValue({ state: stateCandidate.toUpperCase() })
        const cityVal = tokens.slice(0, -1).join(' ').trim()
        if (cityVal && !looksLikeCountry(cityVal)) {
          contactDtls.patchValue({ city: cityVal })
        }
      } else if (!looksLikeCountry(cityState)) {
        contactDtls.patchValue({ city: cityState, state: 'IN' })
      }
    }
    if (parts.length >= 3 && parts[2]) {
      const postalCountry = parts[2]
      const match = postalCountry.match(/^(\d{5}(?:-\d{4})?)\s+(.+)$/) || postalCountry.match(/^(\S+)\s+(.+)$/)
      if (match) {
        if (looksLikePostalCode(match[1])) {
          contactDtls.patchValue({ postalcode: match[1] })
          this.concatpostal = match[1]
        }
        contactDtls.patchValue({ country: match[2] })
      } else if (looksLikePostalCode(postalCountry)) {
        contactDtls.patchValue({ postalcode: postalCountry })
        this.concatpostal = postalCountry
      }
    }
  }
  concataddresspopup() {
    this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(this.concatstreet)
    this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(this.concatpostal)
    this.showconcataddresspopup = false
  }
  arrayStructure =
    [
      { "category": "Addresses", "code": 0 },
      { "category": "Street Centerlines", "code": 1 },
      {
        "category": "Water Structures",
        "code": 2,
        "objects": [
          { "category": "System Valve", "code": 3 },
          { "category": "Service Valve", "code": 4 },
          { "category": "Hydrant", "code": 5 },
          { "category": "Fitting", "code": 6 },
          { "category": "Control Valve", "code": 7 },
          { "category": "Service Connection", "code": 8 },
          { "category": "Network Structure", "code": 9 },
          { "category": "Main", "code": 10 },
          { "category": "Service Line", "code": 11 },
          { "category": "Easement Line", "code": 12 },
          { "category": "Casing", "code": 13 }
        ]
      },
      {
        "category": "Sewer Stormwater Structures",
        "code": 14,
        "objects": [
          { "category": "Network Structure", "code": 15 },
          { "category": "Manhole", "code": 16 },
          { "category": "Inlet", "code": 17 },
          { "category": "Fitting", "code": 18 },
          { "category": "Discharge Point", "code": 19 },
          { "category": "Control Valve", "code": 20 },
          { "category": "Cleanout", "code": 21 },
          { "category": "Catch Basin", "code": 22 },
          { "category": "Gravity Main", "code": 23 },
          { "category": "Pressurized Main", "code": 24 },
          { "category": "Lateral Line", "code": 25 },
          { "category": "Easement Line", "code": 26 },
          { "category": "Casing", "code": 27 }
        ]
      },
      { "category": "Park Amenities", "code": 28 },
      { "category": "Property Line", "code": 29 },
      { "category": "Snow Route", "code": 30 },
      { "category": "Street Resurfacing", "code": 31 },
      { "category": "Regulated Drains", "code": 32 },
      { "category": "Municipal Boundary", "code": 33 },
      { "category": "Leak Pickup Areas", "code": 34 },
      { "category": "Trash Recycle Pickup", "code": 35 },
      { "category": "Parks", "code": 36 },
      { "category": "Historic District", "code": 37 },
      { "category": "Neighborhoods", "code": 38 },
      { "category": "Subdivisions", "code": 39 },
      { "category": "City Council District", "code": 40 },
      { "category": "NCE Areas", "code": 41 },
      { "category": "Election Precinct", "code": 42 },
      { "category": "Township", "code": 43 },
      { "category": "Zip Code", "code": 44 },
      { "category": "Voting Locations", "code": 45 },
      { "category": "Zoning", "code": 46 }
    ]

    getImageSrcforActiveService(casetype_name: string): string {
      // return 'assets/images/casetypeImage/'+casetype_name.replace(/\s|\/+/g, "").toLowerCase()+'.svg'

      return casetype_name?'assets/images/casetypeImage/'+casetype_name.replace(/\s|\/+/g, "").toLowerCase()+'.svg':''
    }

    custompropertyAssign()
    {
      (this.addressDetailsForm.get(['locationDtls', 'postalcode']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'withinlimits']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'jurisdiction']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'zoning']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'recycleweek']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'collectionday']) as any).customProperty = 'enable';
      (this.addressDetailsForm.get(['locationDtls', 'parcelnumber']) as any).customProperty = 'enable';
    }

    // tablocalstoragedata:any={}
    formsubmitted:boolean;
    garbagecollectionday:any='';
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['componentData']?.firstChange) return
    if (changes['componentData'] && this.componentData?.serviceDetails && this.addressDetailsForm && this.tab_title) {
      const savedContact = this.submitandcontinueitem?.contactdata?.[0]
      if (savedContact && !this.requiresDefaultAnonymousCasetype()) {
        this.repopulateContactForm(savedContact)
      }
    }
  }

  ngOnInit() {
    this.GISERROR=false;
    this.isLocationSearch =true
    this.activeinfobutton=false
    this.formsubmitted=false
    console.log(this.agentscriptservice.AlldataArray)
    // this.updateValidators();
    this.addaddressdetails = false

    this.picklist()
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    console.log("in addressdetail.ts")

    console.log(this.agentscriptservice.submitandcontinue)

    // if(this.agentscriptservice.assign())
    // this.componentData=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
    // console.log(this.serviceTypeInfo)
    console.log(this.componentData)

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'casetypedata', this.componentData)

    this.standardservice.SavetolocalStorage('addressdetailscomponent',{data:this.componentData,name:this.tab_title})


    // this.agentscriptservice.updateOrInsertArray(this.tab_title,'dataInfo',
    //   {
    //     "casetypename":this.componentData.serviceDetails.content,
    //     "divisionname":this.componentData.serviceDetails.division.name,
    //     "departmentname":this.componentData.serviceDetails.department.name
    //   }
    // )

    // this.dataInfo=[
    //   {
    //     "casetypename":this.componentData.serviceDetails.content,
    //     "divisionname":this.componentData.serviceDetails.division.name,
    //     "departmentname":this.componentData.serviceDetails.department.name
    //   }
    // ]
    this.anonymouscontact = false
    this.contactDetailFieldsReadOnly = true
    this.dataInformation.emit();
    // this.agentscriptservice.casetypename=this.componentData.serviceDetails.content
    // this.agentscriptservice.divisionname=this.componentData.serviceDetails.division.name
    // this.agentscriptservice.departmentname=this.componentData.serviceDetails.department.name
    // this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',this.componentData.serviceDetails)
    console.log(this.agentscriptservice.AlldataArray)
    // console.log(this.nearbyIncidents)
    // this.agentscriptservice.Associated=false;

    // console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))
    // console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    // console.log(this.agentscriptservice.fetchData(this.tab_title,'mapdata'))

    // this.nearbyIncidents=
    this.data = this.componentData.serviceDetails
    // console.log("deiiiiiiiiiiiiiiii",this.data)
    this.addressDetailsForm = this.fb.group({
      contactDtls: this.fb.group({
        anonymous: [],
        contactid: [null],
        fullcontact: ['', [Validators.required]],
        firstname: ['', [Validators.required]],
        lastname: ['', [Validators.required]],
        emailaddress: [''],
        phonenumber1: [''],
        phonenumber2: [''],
        emailalt1: [''],
        mailingadd: [''],

        // concataddressDtls: this.fb.group({
        street: [''],
        city: [''],
        country: [''],
        state: [''],
        postalcode: ['']
        // })
        // serviceadd: [''],
        //
      }, { validator: this.emailValidator }),
      locationDtls: this.fb.group({
        addresstype: ['1362', [Validators.required]],
        addressline1: ['', [Validators.required]],
        addressline2: [''],
        city: ['', [Validators.required]],
        state: ['', [Validators.required]],
        latitude: ['', [Validators.required]],
        longitude:['', [Validators.required]],
        postalcode:['', [Validators.required]],
        withinlimits: ['', [Validators.required]],
        jurisdiction: [''],
        zoning: [''],
        recycleweek: [''],
        collectionday: [''],
        parcelnumber: [''],
        next_collection_day: [''],
        addaddressdetailscheckbox: ['']
        // parentid:[null]
        // sla: [''],
      })
    });

    this.custompropertyAssign();
    if (this.componentData.serviceDetails.casetypeid == '296') {
      this.removeValidatorsFromLocationDtls()
    }
    console.log(this.addressDetailsForm.value)
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'modifiedfromanonymouscontact'))
    let contactdetails_submit: any;
    if (this.agentscriptservice.submitandcontinue) {
      console.log(this.agentscriptservice.AlldataArray)
      let item = this.agentscriptservice.AlldataArray.find(item => item.submitandcontinue.includes(true))
      console.log(item)
      if (item) {
        this.submitandcontinueitem = item
        contactdetails_submit = this.agentscriptservice.fetchData(item.refno, 'contactdata')
        var locationdetails_submit = this.agentscriptservice.fetchData(item.refno, 'locationdata')
        var mapdata_submit = this.agentscriptservice.fetchData(item.refno, 'mapdata')
        var addaddressdetail_submit=this.agentscriptservice.fetchData(item.refno, 'addaddressdetails')

       

        // this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno ==item.refno) > -1 ? (this.agentscriptservice.AlldataArray.splice(this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno == item.refno), 1),console.log('found ',item.refno)) : console.log('not found ',item.refno);
        console.log(this.agentscriptservice.AlldataArray)

        // for submit and continue in giserror
        var giserror_submit=this.agentscriptservice.fetchData(item.refno, 'giserror')
        var addressdetailform_submit=this.agentscriptservice.fetchData(item.refno, 'addressdetailform')
        var addaddressdetailscheckbox_submit=this.agentscriptservice.fetchData(item.refno, 'addaddressdetailscheckbox')

        // var nearby_alert_incidents =mapdata?.nearbyIncidents?.incidents
        // var nearby_incidents =mapdata?.nearby_alert_incidents?.incidents
      }
    }

    // Apply default anonymous when current casetype requires it (runs for both normal load and submit-and-continue)
    if (this.shouldApplyDefaultAnonymous()) {
      this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(true);
      this.anonymouscontact = true
      let e: any = {
        target: {
          checked: true
        }
      }
      this.toggleVisibility(e)
    }

    if (this.agentscriptservice.fetchData(this.tab_title, 'contactdata') != 0 || this.agentscriptservice.submitandcontinue) {
      var contactdata

      if (this.agentscriptservice.submitandcontinue && this.shouldApplyDefaultAnonymous()) {
        // New tab from submit-and-continue but current casetype needs default anonymous: use anonymous, not previous contact
        // Form already set by shouldApplyDefaultAnonymous/toggleVisibility - fetch it for consistency
        contactdata = this.agentscriptservice.fetchData(this.tab_title, 'contactdata') || {
          anonymous: true,
          contactid: 11,
          fullcontact: 'Anonymous Anonymous',
          firstname: 'Anonymous',
          lastname: 'Anonymous',
          emailaddress: 'anonymous@thesmartcity311.com',
          phonenumber1: '',
          phonenumber2: '',
          emailalt1: '',
          mailingadd: '',
          street: '',
          city: '',
          country: 'United States (US)',
          state: '',
          postalcode: ''
        }
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', contactdata)
        // Form already set by shouldApplyDefaultAnonymous block above - skip prepopulation
      } else if (this.agentscriptservice.submitandcontinue) {
        contactdata = contactdetails_submit
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', contactdata)
      }
      else {
        const savedContactFromSubmit = this.submitandcontinueitem?.contactdata?.[0]
        if (savedContactFromSubmit && !this.requiresDefaultAnonymousCasetype()) {
          contactdata = savedContactFromSubmit
          this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', contactdata)
        } else {
          contactdata = this.agentscriptservice.fetchData(this.tab_title, 'contactdata')
        }
      }

      if (contactdata && contactdata.anonymous) {
        this.anonymouscontact = true
      }
      console.log(this.componentData)
      console.log(contactdata)
      // Skip prepopulation when we applied default anonymous (form already set by toggleVisibility)
      const skipPrepopulation = this.agentscriptservice.submitandcontinue && this.shouldApplyDefaultAnonymous();
      if (!skipPrepopulation) {
        if(this.componentData.serviceDetails.casetypeid===367 && this.componentData.serviceDetails.department.id===207)
        {
          if(contactdata.anonymous===true)
          {
            this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue("");
            this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue("");
          }
          else{
            this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(contactdata.anonymous);
            this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(contactdata.contactid);
            this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(contactdata.firstname +' '+ contactdata.lastname);
            this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(contactdata.firstname);
            this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(contactdata.lastname);
            this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(contactdata.emailaddress);
            this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(contactdata.phonenumber1);
            this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(contactdata.phonenumber2);
            this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue(contactdata.emailalt1);
            this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(contactdata.mailingadd);
          }
        }
        else{
          this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(contactdata.anonymous);
          this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(contactdata.contactid);
          this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(contactdata.firstname +' '+ contactdata.lastname);
          this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(contactdata.firstname);
          this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(contactdata.lastname);
          this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(contactdata.emailaddress);
          this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(contactdata.phonenumber1);
          this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(contactdata.phonenumber2);
          this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue(contactdata.emailalt1);
          this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(contactdata.mailingadd);
          // this.addressDetailsForm.get(['contactDtls', 'serviceadd'])?.setValue(contactdata.serviceadd);

          this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(contactdata.street)
          this.concatstreet=contactdata.street
          this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue("Fort Wayne")
          this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(contactdata.postalcode)
          this.concatpostal=contactdata.postalcode
          this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue(contactdata.country)
          this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue("IN")
        }
      }

      this.syncContactFieldsLockFromForm()

      // this.formsubmited=true

    }

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'addaddressdetails'))

    if (this.agentscriptservice.fetchData(this.tab_title, 'locationdata') != 0 || this.agentscriptservice.submitandcontinue) {
    this.activeinfobutton=true
      var locationdata
      console.log(this.agentscriptservice.submitandcontinue);
      if (this.agentscriptservice.submitandcontinue) {
        locationdata = locationdetails_submit
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', locationdata)
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', mapdata_submit)
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetails', addaddressdetail_submit)

        // for submit and continue in giserror
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', giserror_submit)
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', addressdetailform_submit)
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetailscheckbox', addaddressdetailscheckbox_submit)
      }
      else {
        locationdata = this.agentscriptservice.fetchData(this.tab_title, 'locationdata')
      }
      console.log(locationdata)

      if (this.agentscriptservice.fetchData(this.tab_title, 'addaddressdetailscheckbox')!=0)
        {
          this.invalidaddress = true;
        }
      if(locationdata.addressline1!=null)
      {
        this.garbagecollectionday=locationdata.addressline1;
      }
      console.log(this.garbagecollectionday)

      // check if the castetypeid 367 and hit the esrimap address api and assigning the location details.
      if (this.componentData && this.componentData.serviceDetails && locationdata) {
        if (this.componentData.serviceDetails.casetypeid != 367) {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue(locationdata.addresstype);
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(locationdata.addressline1);
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(locationdata.addressline2);
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(locationdata.city);
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(locationdata.state);
      this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(locationdata.longitude);
      this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(locationdata.latitude);
      this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(locationdata.postalcode);
      this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(locationdata.withinlimits);
      this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(locationdata.jurisdiction);
      this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(locationdata.zoning);
      this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(locationdata.recycleweek);
      this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(locationdata.collectionday);
      this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(locationdata.parcelnumber);
      // this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue(locationdata.next_collection_day);


        }
          else {
        // this.addressDetailsForm.get(['locationDtls','addresstype'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addresstype);
        //this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(locationdata.addressline1);       
        this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue(locationdata.addresstype);        
        this.componentData.serviceDetails.casetypeid = 367
        // if its only address line 1 then set the value and trigger the search else set both address line 1 and 2 and trigger the intersection search
        if(locationdata.addresstype == '1362'){
          this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(locationdata.addressline1);
            setTimeout(() => {
            this.keyupenter()
          }, 100);
        }else{
          this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(locationdata.addressline1);
          this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(locationdata.addressline2);        
          this.onSearchIntersection();
        }
        // this.addressDetailsForm.get(['locationDtls','addressline2'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addressline2);
       
      }
      }

      var mapdata = this.agentscriptservice.fetchData(this.tab_title, 'mapdata')
      console.log(mapdata)
      this.nearbyIncidents = mapdata?.nearby_incidents?.incidents;
      this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
      this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)

      this.alertIncidents = mapdata?.nearby_alert_incidents?.incidents
      // console.log(this.alertIncidents)
      // console.log(this.nearbyIncidents)
      this.loadMap_button = false
      if (this.agentscriptservice.fetchData(this.tab_title, 'addaddressdetails') != 0) {
        console.log("entered")
        this.showcheckbox = true
        this.updateValidators();
        this.loadMap_button = true
      }
      this.agentscriptservice.submitandcontinue = false;
      this.agentscriptservice.updateOrInsertArray(this.submitandcontinueitem.refno, 'submitandcontinue', false)
       this.standardservice.clearlocalStorage('servicepayload', this.submitandcontinueitem.refno)
        this.standardservice.clearlocalStorage('tabdata', this.submitandcontinueitem.refno)
      this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno ==this.submitandcontinueitem.refno) > -1 ? (this.agentscriptservice.AlldataArray.splice(this.agentscriptservice.AlldataArray.findIndex((x: any) => x.refno == this.submitandcontinueitem.refno), 1),console.log('found ',this.submitandcontinueitem.refno)) : console.log('not found ',this.submitandcontinueitem.refno);
    }
    var addaddressdetailscheckbox=this.agentscriptservice.fetchData(this.tab_title,'addaddressdetailscheckbox')
    if(addaddressdetailscheckbox)
    {
      this.addaddressdetails = true
      this.isLocationSearch =false
      this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(true);
    }

    // this.addressDetailsForm.get(['locationDtls', 'parentid'])?.setValue(null)


    // this.clearForm();
    // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.contactDtls) {

    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))
    //   this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.anonymous);
    //   this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.fullcontact);
    //   this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.firstname);
    //   this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.lastname);
    //   this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.emailaddress);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.phonenumber1);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.phonenumber2);
    //   this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.mailingadd);
    //   this.addressDetailsForm.get(['contactDtls', 'serviceadd'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.serviceadd);
    //   // this.nearbyIncidents=this.serviceTypeInfo.serviceDetails.nearbyIncidents
    //   // console.log(this.serviceTypeInfo.serviceDetails)
    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))


    // }
    // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.locationDtls) {

    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    //   this.loadMap_button = false;

    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)
    //   var mapdata = this.agentscriptservice.fetchData(this.tab_title, 'mapdata')
    //   console.log(mapdata)
    //   this.nearbyIncidents = mapdata?.nearby_incidents?.incidents

    //   this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addresstype);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addressline1);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addressline2);
    //   this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.city);
    //   this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.state);
    //   this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.longitude);
    //   this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.latitude);
    //   this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.postalcode);
    //   this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.withinlimits);
    //   this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.jurisdiction);
    //   this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.zoning);
    //   this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.recycleweek);
    //   // this.addressDetailsForm.get(['locationDtls','collectionday'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.collectionday);
    //   this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
    //   this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.parcelnumber);
    //   // this.nearbyIncidents=this.serviceTypeInfo.serviceDetails.nearbyIncidents
    //   // console.log(this.serviceTypeInfo.serviceDetails)
    //   // this.addressDetailsForm.get(['locationDtls','sla'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.sla);
    // }
    // this.performAddressSearch(this.searchAddress);
    // this.nearbyIncidents=this.componentData.serviceDetails.nearbyIncidents
    //   console.log(this.componentData.serviceDetails)
    // this.addressDetailsForm.get('contactDtls.phonenumber1')?.setValue(this.formatPhoneNumber('+17654909576'))
    console.log(this.apiservice.gensysdata)
    if (
      !(
      this.componentData.serviceDetails.department.id == 199 ||
      this.componentData.serviceDetails.casesubtypeid == 339 ||
      this.componentData.serviceDetails.casetypeid == 308 ||
      this.componentData.serviceDetails.casetypeid == 307 ||
      ((this.componentData.serviceDetails.casetypeid == 243 || this.componentData.serviceDetails.casetypeid == 211) &&
        this.componentData.serviceDetails.department.id == 200)
    ) &&
    (
      (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) ||
      this.agentscriptservice.fetchData(this.tab_title, 'genesysdata') != 0
    )) {
      console.log(this.apiservice.gensysdata)
      if(this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData)
        {
          const name = this.apiservice.gensysdata.geneSysData.firstname;
      if (name) {
        const nameParts = name.split(' ');

        // Set first name and last name
        if (nameParts.length > 1) {
          this.addressDetailsForm.get('contactDtls.firstname')?.setValue(nameParts[0]);
          this.addressDetailsForm.get('contactDtls.lastname')?.setValue(nameParts.slice(1).join(' '));
        } else {
          this.addressDetailsForm.get('contactDtls.firstname')?.setValue(name);
        }
      }


      // Assign the firstname value from geneSysData to the corresponding form control
      this.addressDetailsForm.get('contactDtls.phonenumber1')?.setValue(this.formatPhoneNumber(this.apiservice.gensysdata.geneSysData.phonenumber))
      // this.addressDetailsForm.get('contactDtls.phonenumber1')?.setValue(this.formatPhoneNumber('+17654909576'))

      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
      var gendata=this.apiservice.gensysdata
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'genesysdata', gendata)

      this.openModalPopup();
      this.apiservice.gensysdata=null
        }


    }
    // console.log(this.agentscriptservice.AlldataArray)
    // console.log(this.apiservice.gensysdata.geneSysData.phonenumber)
    // code to be written
    var addressdetailform = this.agentscriptservice.fetchData(this.tab_title, 'addressdetailform')
    console.log(addressdetailform)
    console.log(this.addressDetailsForm)
    if (addressdetailform != 0) {
   const locationdtls=this.addressDetailsForm.get(['locationDtls'])
   if (locationdtls instanceof FormGroup) {

      addressdetailform.forEach(field => {


        const control = locationdtls.get(field.name)

        if (control) {
          // if (field.value=='') {
          //   // control.setValue(field.value);
            (control as any).customProperty = field.customProperty;
          // } else {
          //   // control.setValue('');
          //   (control as any).customProperty = 'disable';
          // }
        }
      });

      }
    }
    // console.log(this.addressDetailsForm)
    if (this.agentscriptservice.fetchData(this.tab_title, 'giserror') == 1) {
      this.GISERROR = true;
      this.removeValidatorsFromLocationDtls()
    }
    if(mapdata && mapdata.status) if(mapdata.status.toLowerCase()=='ok') this.isGisVerified=true 
  }
  constructor(private _standardUiService: StandardUIService, private apiservice: ApiserviceService, private elementRef: ElementRef, public dialog: MatDialog, private fb: FormBuilder,private standardservice:StandardUIService, private agentscriptservice: AgentscriptService_updated) {
    const requiredWithEmptyString: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
      return control.value !== null && control.value !== undefined ? null : { 'required': true };
    }
  }
  highlightedIndex: number = -1; // track which item is highlighted
  onKeyDown(event: KeyboardEvent, dropdown: any) {
    // console.log('keydown')
    if (event.key === 'ArrowDown') {
      event.preventDefault(); // prevent cursor moving
      if (this.entiredata?.length > 0) {
        // console.log('ArrowDown')
        this.highlightedIndex = (this.highlightedIndex + 1) % this.entiredata.length;
        this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(this.entiredata[this.highlightedIndex].text)

      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.entiredata?.length > 0) {
        this.highlightedIndex =
          (this.highlightedIndex - 1 + this.entiredata.length) % this.entiredata.length;
        this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(this.entiredata[this.highlightedIndex].text)
      }
    } else if (event.key === 'Enter' && this.highlightedIndex >= 0) {
      event.preventDefault();
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(this.entiredata[this.highlightedIndex].text)
      // this.assignaddress(this.entiredata[this.highlightedIndex].text);
    } else if (event.key === 'Tab') {
      this.highlightedIndex = -1; // clear highlight if needed
      dropdown.close();
    }
  }
  emailValidator(group: FormGroup) {
    const emailControl = group.get('emailaddress');
    const emailValue = emailControl?.value;

    if (emailValue && emailValue !== null && emailValue !== '') {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9._%+-]+\.[a-zA-Z]{2,}$/;

      if (emailPattern.test(emailValue)) {
        emailControl.setErrors(null); // Valid email format
        return null;
      } else {
        emailControl.setErrors({ invalidEmail: true }); // Invalid email format
        return { invalidEmail: true };
      }
    } else {
      emailControl.setErrors(null); // No email provided, hence no error
      return null;
    }
  }
  // indexassociated:number
  associateditem: any
  toggleAssociate(item: any) {
    console.log(item)
    // this.indexassociated=index
    this.associateditem = item
    // this.Associated = true;
    console.log(this.associateditem)

    this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", item)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", true)
    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

    // this.addressDetailsForm.get(['locationDtls', 'parentid'])?.setValue(item.id)

    // console.log(this.agentscriptservice.AlldataArray['associateddata']?.length>0)
  }

  concataddress() {
    const contactDtls = this.addressDetailsForm.get('contactDtls') as FormGroup;

    if (contactDtls) {

      const street = contactDtls.get('street')?.value ? contactDtls.get('street').value+' ' : '';
      const city = contactDtls.get('city')?.value ?  '\n' + contactDtls.get('city').value + ' ' : '';
      const state = contactDtls.get('state')?.value ? contactDtls.get('state').value.toUpperCase() + ' \n' : '';
      const postalcode = contactDtls.get('postalcode')?.value ? contactDtls.get('postalcode').value + ' ' : '';
      const country = contactDtls.get('country')?.value ? contactDtls.get('country').value : '';

      const mailingAddress = `${street}${city}${state}${postalcode}${country}`;

      contactDtls.get('mailingadd')?.setValue(mailingAddress);

      this.concatstreet=contactDtls.get('street')?.value ? contactDtls.get('street').value : ''
      this.concatpostal=contactDtls.get('postalcode')?.value ? contactDtls.get('postalcode').value + ' ' : '';

      this.concatstreet=street
      this.concatpostal=postalcode

      this.concataddresspopup();

    }

    // console.log("concat address")
  }

  showAlertWithAction() {
    Swal.fire({
      title: 'Disassociate',
      html: "Are you Sure?",
      type: 'Success',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.disassociate();
      }
    });

  }

  confirmDisassociate() {
    // $('.confirmationModal').modal('show');
    this.showAlertWithAction()
  }
  formatDate(timestamp: string): string {
    let date: Date;
    try {
      date = new Date(timestamp);
      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
    } catch (error) {
      console.error('Invalid timestamp format:', error);
      return 'Invalid timestamp';
    }

    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: 'America/New_York'
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

    const now = new Date();
    const estOffset = 5 * 60 * 60 * 1000; // EST offset is UTC-5
    const diffInSeconds = Math.floor((now.getTime() - date.getTime() + estOffset) / 1000);

    let timeAgo = '';
    if (diffInSeconds < 60) {
      timeAgo = `${diffInSeconds} seconds ago`;
    } else if (diffInSeconds < 3600) {
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      timeAgo = `${diffInMinutes} minutes ago`;
    } else if (diffInSeconds < 86400) {
      const diffInHours = Math.floor(diffInSeconds / 3600);
      timeAgo = `${diffInHours} hours ago`;
    } else {
      const diffInDays = Math.floor(diffInSeconds / 86400);
      timeAgo = `${diffInDays} days ago`;
    }

    // Remove "at" from the formatted date
    const formattedDateWithoutAt = formattedDate.replace('at', '');

    return `${formattedDateWithoutAt} (${timeAgo})`;
  }



  disassociate() {
    // Disassociate logic here
    // this.addressDetailsForm.get(['locationDtls', 'parentid'])?.setValue(null)

    // this.indexassociated=$
    // this.Associated = false;
    // $('.confirmationModal').modal('hide');
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)
    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

  }

  getPhonenumber() {
    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
      const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
      console.log(phoneNumberInput.value)
      return phoneNumberInput.value
    }
    return 0

  }
  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.startsWith('+1')) {
      phoneNumber = phoneNumber.substring(2);
    }
    // Remove all non-numeric characters from the phone number
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Apply the phone number format (XXX) XXX-XXXX
    const formattedPhoneNumber = numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    return formattedPhoneNumber;
  }
  maddress: any;
  mailingaddress(checked: any) {
    this.addressDetailsForm.get('locationDtls')?.reset();

    const mailingAddress = this.addressDetailsForm?.get('contactDtls.street')?.value;

    console.log(mailingAddress)
    var mailadd = mailingAddress.toLowerCase()
    if (checked) {
      this.triggerDropdown()
      if (mailadd.includes(' and ') || mailadd.includes(' & ')) {
        var addressParts= mailingAddress.toLowerCase();
        console.log("in intersection")
        const parts = mailingAddress.split(/ & | and /);
        const firstPart = parts[0].trim();
        const secondPart = parts[1].trim();

        this.addressDetailsForm?.get('locationDtls.addresstype')?.setValue('1363'); // Assuming '1363' represents Intersection type
        this.addressDetailsForm?.get('locationDtls.addressline1')?.setValue(firstPart);
        this.addressDetailsForm?.get('locationDtls.addressline2')?.setValue(secondPart);
      }
      else {
        console.log("in address" + mailingAddress)
        // var mailadd=mailingAddress.toLowerCase()
        // let parts = mailadd.split('fort');
        var addressParts = mailadd
        this.addressDetailsForm?.get('locationDtls.addressline1')?.setValue(addressParts);
        this.addressDetailsForm?.get('locationDtls.addresstype')?.setValue('1362'); // Assuming '1362' represents Address type
      }
      console.log(mailingAddress, mailadd);
      this.performAddressSearch(addressParts);
    } else {
      this.entiredata = []
      this.clearForm();
      this.clearmap();
      this.isGisVerified = false
    }
  }

  checkaddress(checked: any) {
    console.log(this.assignentireaddress)
    if (checked) {
      // var addtomailinaddress=this.addressDetailsForm.get(['locationDtls', 'addressline1']).value
      this.assignentireaddress = this.assignentireaddress.replace(', ', '\n')
      var addtomailinaddress = this.assignentireaddress.replaceAll(', ', ' ')
      const addresslineControl = this.addressDetailsForm.get(['locationDtls', 'addressline2']);
      // if (!(addresslineControl.value == null || addresslineControl.value == '' || addresslineControl.value == undefined))
      // {
      // addtomailinaddress=addtomailinaddress+' & '+addresslineControl.value
      // }

      const addressline1 = this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.value || '';
      const addressline2 = this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.value ? ' & ' + this.addressDetailsForm.get(['locationDtls', 'addressline2']).value : '';
      const addressline = addressline1 + addressline2;
      console.log(addressline)
      const city = this.addressDetailsForm.get(['locationDtls', 'city']).value ? this.addressDetailsForm.get(['locationDtls', 'city']).value + ' ' : ''
      const state = this.addressDetailsForm.get(['locationDtls', 'state']).value ? this.addressDetailsForm.get(['locationDtls', 'state']).value : 'IN'
      const postalcode = this.addressDetailsForm.get(['locationDtls', 'postalcode']).value ? this.addressDetailsForm.get(['locationDtls', 'postalcode']).value + ' ' : ''
      const country = 'United States (US)'



      this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(addressline);
      this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue(city);
      this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(postalcode);
      this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue(state);
      this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue(country);

      this.concataddress()

      // this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(`${addressline}${city}${state}${postalcode}${country}`);

      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
      // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

      this.syncContactFieldsLockFromForm()
    }
    else {
      // console.log("hehe")
    }
  }

  rowcolumns: any
  getcolumnvalues(id: any) {
    const index = this.rowcolumns.findIndex(column => column == id);
    // console.log(index);
    return index;
  }

  concatstreet:any=''
  concatpostal:any=''

  handleContactFieldAreaClick(event: MouseEvent): void {
    if (this.isFieldDisabled()) {
      return
    }
    const t = event.target as HTMLElement
    if (t.closest('.contact-field-ignore-open')) {
      return
    }
    this.openModalPopup()
  }

  openModalPopup(): void {
    const dialogRef = this.dialog.open(AddressDialogComponent, {
      width: '70vw',
      data: { phonenumber: this.addressDetailsForm.get(['contactDtls', 'phonenumber1']).value }
    });

    dialogRef.afterClosed().subscribe(entireresult => {

      this.rowcolumns = entireresult.rowcolumns
      console.log('The dialog was closed');
      console.log(entireresult)
      console.log(entireresult?.rowdata.length)
      if (entireresult.rowdata.length > 0) {
        var result = entireresult.rowdata
        console.log(result)
        // const concatenatedValue = result.slice(7, 11).join(' ');
        console.log("Object.keys(result).length", Object.keys(result).length)
        if (Object.keys(result).length > 0) {
          this.anonymouscontact = false
          this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(result[this.getcolumnvalues('Contact Id')]);
          this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(result[this.getcolumnvalues('First Name')] + " "+result[this.getcolumnvalues('Last Name')]);
          this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(result[this.getcolumnvalues('First Name')]);
          this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(result[this.getcolumnvalues('Last Name')]);
          this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(result[this.getcolumnvalues('Email Address')]);
          this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(result[this.getcolumnvalues('Phone Number')]);
          this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(result[this.getcolumnvalues('Alternate Phone')]);
          this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue(result[this.getcolumnvalues('Alternate Email')]);
          // var addressline = result[this.getcolumnvalues('Address Line 1')]
          // console.log(addressline)
          // if (addressline.includes(' null ') || addressline == 'null' || addressline.includes('\nnull')) {
          //   console.log("it has null" + addressline)
          //   addressline = addressline.replaceAll('null', '')
          //   console.log(addressline)
          // }
          // this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(addressline);

          this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(result[this.getcolumnvalues('Street')]);
          this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue(result[this.getcolumnvalues('City')]);
          this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(result[this.getcolumnvalues('Postalcode')]);
          this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue('United States (US)');
          this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue('IN');

          this.concatstreet=result[this.getcolumnvalues('Street')]
          this.concatpostal=result[this.getcolumnvalues('Postalcode')]

          this.concataddress()


          this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(false);
          const anonymous = document.querySelector('input[type="checkbox"][formControlName="anonymous"]');
          console.log(anonymous)
          if (anonymous) {
            (anonymous as HTMLInputElement).checked = false;
          }

          const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
          if (issame) {
            (issame as HTMLInputElement).checked = false;
          }


          if (this.sameAsServiceAddressCheckbox) {
            this.sameAsServiceAddressCheckbox.nativeElement.checked = false;
          }

        }

        if (this.addressDetailsForm.get(['contactDtls', 'contactid']).value === '11') {

          // if (this.addressDetailsForm.get(['contactDtls', 'fullcontact']).value.toLowerCase().includes('anonymous')) {
          this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(true);
          this.anonymouscontact = true
          const anonymous = document.querySelector('input[type="checkbox"][formControlName="anonymous"]');
          console.log(anonymous)
          if (anonymous) {
            (anonymous as HTMLInputElement).checked = true;
          }

        }
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
        // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

        console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))

        this.resetContactFieldEditConfirmations()

      }
      this.syncContactFieldsLockFromForm()
      // Do something after modal is closed if needed

    });
  }


  // search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
  // 	text$.pipe(
  // 		debounceTime(200),
  // 		distinctUntilChanged(),
  // 		map((term) =>
  // 			term.length < 2 ? [] : states.filter((v) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
  // 		),
  // 	);



  anonymouscontact: boolean
  /** When true, contact detail fields (not the Contact picker) are read-only until a contact is chosen from search. */
  contactDetailFieldsReadOnly = true

  isContactDetailFieldsReadOnly(): boolean {
    return this.contactDetailFieldsReadOnly && !this.anonymouscontact
  }

  /** First name, last name, email, primary phone — warn before editing when field already has data after contact selection. */
  private contactFieldEditConfirmed = new Set<ContactProtectedField>()
  private contactEditSwalBlocking = false

  private resetContactFieldEditConfirmations(): void {
    this.contactFieldEditConfirmed.clear()
  }

  private shouldOfferContactFieldEditConfirm(): boolean {
    if (!this.addressDetailsForm || this.anonymouscontact || this.isContactDetailFieldsReadOnly()) {
      return false
    }
    const id = this.addressDetailsForm.get(['contactDtls', 'contactid'])?.value
    if (id == null || id === '' || id === 11 || id === '11') {
      return false
    }
    return true
  }

  onProtectedContactFieldBeforeInput(field: ContactProtectedField, ev: Event): void {
    const inputEvent = ev as InputEvent
    if (!this.shouldOfferContactFieldEditConfirm()) {
      return
    }
    if (this.contactFieldEditConfirmed.has(field)) {
      return
    }

    const target = inputEvent.target as HTMLInputElement
    if (!target || target.disabled) {
      return
    }

    const val = target.value ?? ''
    if (!String(val).trim()) {
      return
    }

    const type = inputEvent.inputType
    if (!type || type === 'historyUndo' || type === 'historyRedo') {
      return
    }

    if (type === 'insertFromPaste') {
      return
    }

    if (this.contactEditSwalBlocking) {
      inputEvent.preventDefault()
      return
    }

    inputEvent.preventDefault()

    const selStart = target.selectionStart ?? val.length
    const selEnd = target.selectionEnd ?? val.length
    const data = inputEvent.data

    this.contactEditSwalBlocking = true
    Swal.fire({
      title: 'Confirm change',
      text: 'Do you really want to update this field value?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result: { value?: boolean; isConfirmed?: boolean }) => {
      this.contactEditSwalBlocking = false
      const ok = !!(result && (result.value === true || result.isConfirmed))
      if (!ok) {
        return
      }

      this.contactFieldEditConfirmed.add(field)
      let next = val
      if (type === 'insertText' && data != null) {
        next = val.slice(0, selStart) + data + val.slice(selEnd)
      } else if (type === 'deleteContentBackward') {
        if (selStart !== selEnd) {
          next = val.slice(0, selStart) + val.slice(selEnd)
        } else if (selStart > 0) {
          next = val.slice(0, selStart - 1) + val.slice(selEnd)
        }
      } else if (type === 'deleteContentForward') {
        if (selStart !== selEnd) {
          next = val.slice(0, selStart) + val.slice(selEnd)
        } else {
          next = val.slice(0, selStart) + val.slice(selEnd + 1)
        }
      } else if (type === 'deleteByDrag' || type === 'deleteByCut') {
        if (selStart !== selEnd) {
          next = val.slice(0, selStart) + val.slice(selEnd)
        }
      } else {
        return
      }

      this.addressDetailsForm.get(['contactDtls', field])?.setValue(next, { emitEvent: true })
      this.scheduleContactFieldCaret(target, field, type, selStart, selEnd, data)
    })
  }

  onProtectedContactFieldPaste(field: ContactProtectedField, ev: ClipboardEvent): void {
    if (!this.shouldOfferContactFieldEditConfirm()) {
      return
    }
    if (this.contactFieldEditConfirmed.has(field)) {
      return
    }

    const target = ev.target as HTMLInputElement
    const val = target.value ?? ''
    if (!String(val).trim()) {
      return
    }

    if (this.contactEditSwalBlocking) {
      ev.preventDefault()
      return
    }

    ev.preventDefault()

    const text = ev.clipboardData?.getData('text') ?? ''
    const selStart = target.selectionStart ?? val.length
    const selEnd = target.selectionEnd ?? val.length

    this.contactEditSwalBlocking = true
    Swal.fire({
      title: 'Confirm change',
      text: 'Do you really want to update this field value?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result: { value?: boolean; isConfirmed?: boolean }) => {
      this.contactEditSwalBlocking = false
      const ok = !!(result && (result.value === true || result.isConfirmed))
      if (!ok) {
        return
      }

      this.contactFieldEditConfirmed.add(field)
      const next = val.slice(0, selStart) + text + val.slice(selEnd)
      this.addressDetailsForm.get(['contactDtls', field])?.setValue(next, { emitEvent: true })
      setTimeout(() => {
        target.focus()
        const len = (this.addressDetailsForm.get(['contactDtls', field])?.value ?? '').toString().length
        const pos = Math.min(selStart + text.length, len)
        target.setSelectionRange(pos, pos)
      }, 0)
    })
  }

  private scheduleContactFieldCaret(
    el: HTMLInputElement,
    field: ContactProtectedField,
    type: string,
    selStart: number,
    selEnd: number,
    data: string | null
  ): void {
    setTimeout(() => {
      el.focus()
      const current = (this.addressDetailsForm.get(['contactDtls', field])?.value ?? '').toString()
      const len = current.length
      let pos = selStart
      if (type === 'insertText' && data) {
        pos = selStart + data.length
      } else if (type === 'deleteContentBackward') {
        pos = selStart !== selEnd ? selStart : Math.max(0, selStart - 1)
      } else if (type === 'deleteContentForward') {
        pos = selStart !== selEnd ? selStart : selStart
      } else if (type === 'deleteByDrag' || type === 'deleteByCut') {
        pos = selStart
      }
      pos = Math.min(Math.max(0, pos), len)
      el.setSelectionRange(pos, pos)
    }, 0)
  }

  private syncContactFieldsLockFromForm(): void {
    if (!this.addressDetailsForm) return
    if (this.anonymouscontact) return
    const c = this.addressDetailsForm.get('contactDtls') as FormGroup
    if (!c) return
    const contactid = c.get('contactid')?.value
    const fullcontact = (c.get('fullcontact')?.value ?? '').toString().trim()
    if (
      contactid != null && contactid !== '' &&
      contactid !== 11 && contactid !== '11' &&
      fullcontact !== ''
    ) {
      this.contactDetailFieldsReadOnly = false
    } else {
      this.contactDetailFieldsReadOnly = true
    }
  }

  preventLabelClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
  toggleVisibility(e: any) {
    this.resetContactFieldEditConfirmations()

    const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
    if (issame) {
      (issame as HTMLInputElement).checked = false;
    }

    this.anonymouscontact = e.target.checked;

    // this.isAnonymous = this.isAnonymous;
    // this.isAnonymous = e.target.checked;
    // const contactField = this.formGroup.get('contact');

    // if (this.isAnonymous) {
    //   contactField.enable();
    // } else {
    //   contactField.disable();
    // }

    if (e.target.checked) {
      // this.isAnonymous=true
      this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(11)
      this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue("Anonymous Anonymous");
      this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue("Anonymous");
      this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue("Anonymous");
      this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue("anonymous@thesmartcity311.com");
      this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue("");
      // this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue("United States (US)");
      this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue("United States (US)");
      this.concataddress()
    } else {

      // this.isAnonymous=false
      this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(null)
      this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue("");
      this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue("");


    }

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
    console.log(this.addressDetailsForm.get(['contactDtls']).value)
    // console.log(this.tablocalstoragedata)

    // this.tablocalstoragedata['contactdata']=this.addressDetailsForm.get(['contactDtls']).value
    // console.log(this.tablocalstoragedata)
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))

    this.syncContactFieldsLockFromForm()



  }
  /** Repopulate contact form from saved contact (used when switching to non-anonymous casetype after submit-and-continue) */
  repopulateContactForm(contactdata: any): void {
    if (!contactdata || !this.addressDetailsForm) return
    this.anonymouscontact = !!contactdata.anonymous
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', contactdata)
    if (this.componentData?.serviceDetails?.casetypeid === 367 && this.componentData?.serviceDetails?.department?.id === 207) {
      if (contactdata.anonymous) {
        this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue('')
        this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue('')
      } else {
        this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(contactdata.anonymous)
        this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(contactdata.contactid)
        this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(contactdata.firstname + ' ' + contactdata.lastname)
        this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(contactdata.firstname)
        this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(contactdata.lastname)
        this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(contactdata.emailaddress)
        this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(contactdata.phonenumber1)
        this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(contactdata.phonenumber2)
        this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue(contactdata.emailalt1)
        this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(contactdata.mailingadd)
        if (contactdata.street != null && contactdata.street !== '') {
          this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(contactdata.street)
          this.concatstreet = contactdata.street
        }
        if (contactdata.postalcode != null && contactdata.postalcode !== '') {
          this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(contactdata.postalcode)
          this.concatpostal = contactdata.postalcode
        }
        this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue(contactdata.city || 'Fort Wayne')
        this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue(contactdata.state || 'IN')
        this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue(contactdata.country || 'United States (US)')
      }
    } else {
      this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(contactdata.anonymous)
      this.addressDetailsForm.get(['contactDtls', 'contactid'])?.setValue(contactdata.contactid)
      this.addressDetailsForm.get(['contactDtls', 'fullcontact'])?.setValue(contactdata.firstname + ' ' + contactdata.lastname)
      this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(contactdata.firstname)
      this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(contactdata.lastname)
      this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(contactdata.emailaddress)
      this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(contactdata.phonenumber1)
      this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(contactdata.phonenumber2)
      this.addressDetailsForm.get(['contactDtls', 'emailalt1'])?.setValue(contactdata.emailalt1)
      this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(contactdata.mailingadd)
      this.addressDetailsForm.get(['contactDtls', 'street'])?.setValue(contactdata.street)
      this.concatstreet = contactdata.street
      this.addressDetailsForm.get(['contactDtls', 'city'])?.setValue('Fort Wayne')
      this.addressDetailsForm.get(['contactDtls', 'postalcode'])?.setValue(contactdata.postalcode)
      this.concatpostal = contactdata.postalcode
      this.addressDetailsForm.get(['contactDtls', 'country'])?.setValue(contactdata.country)
      this.addressDetailsForm.get(['contactDtls', 'state'])?.setValue('IN')
    }
    this.syncContactFieldsLockFromForm()
    this.resetContactFieldEditConfirmations()
  }

  /** Casetypes that require default anonymous (NCC 199, casesubtype 339, 308, 307, 243/211 with dept 200) */
  requiresDefaultAnonymousCasetype(): boolean {
    const { department, casetypeid, casesubtypeid } = this.componentData?.serviceDetails || {};
    const deptId = department?.id;
    return !!(
      deptId == 199 ||
      casesubtypeid == 339 ||
      casetypeid == 308 ||
      casetypeid == 307 ||
      ((casetypeid == 243 || casetypeid == 211) && deptId == 200)
    );
  }

  /** Whether to apply default anonymous for current casetype (and user has not modified from anonymous) */
  shouldApplyDefaultAnonymous(): boolean {
    return this.requiresDefaultAnonymousCasetype() && this.agentscriptservice.fetchData(this.tab_title, 'modifiedfromanonymouscontact') == 0;
  }

  isFieldDisabled(): boolean {
    const { department, casetypeid,casesubtypeid } = this.componentData.serviceDetails || {};
    const departmentId = department?.id;

    return (
      departmentId === 199 ||
      (casesubtypeid === 339 && departmentId === 207) ||
      ([308, 243, 307, 211].includes(casetypeid) && departmentId === 200)
    );
  }



  clearaddaddressdetails() {
    this.showcheckbox = false;
    this.addaddressdetails = false
    const addaddress = document.querySelector('input[type="checkbox"][id="addaddressdetailscheckbox"]');
    console.log(addaddress)
    if (addaddress) {
      (addaddress as HTMLInputElement).checked = false;
    }
  }

  toggleaddaddress(e: any) {
    if (e.target.checked) {
      this.addaddressdetails = true
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('Fort Wayne')
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")
    }
    else {
      this.addaddressdetails = false
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")


    }
  }

  getfieldvalue(itemname:any,addressvalue:any)
  {
    let item=this.allPicklistArray.find((x:any)=>x.id==addressvalue)
    if(item)
      return item
    return null
  }

  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  @Output() dataInformation = new EventEmitter();
  serviceee: any = [];
  invalidaddresspopup:any;
gotoNext(data: any, type: any) {
  console.log(data);

  console.log(this.addressDetailsForm?.get('locationDtls.addresstype')?.value)
    console.log(this.addressDetailsForm?.get('locationDtls.city')?.value)
    console.log(this.addressDetailsForm.valid)

    this.invalidaddresspopup = data.object;
    const fieldNamesMap: { [key: string]: string } = {
      fullcontact: 'Contact is required field.',
      addressline1: 'Service Address is required field.',
      firstname: 'First Name is required field.',
      lastname: 'Last Name is required field.'
      // emailaddress: 'Email Address is required field.',
      // Add more mappings here as needed
    };

    const excludedFields = ['city', 'state', 'latitude', 'longitude', 'postalcode', 'withinlimits','emailaddress'];

    if (this.addressDetailsForm.invalid && data.object != 'addressdetail' ) {
      const invalidFields = [];
      var locationdata = this.agentscriptservice.fetchData(this.tab_title, 'locationdata');
    console.log(locationdata)
      const controls = this.addressDetailsForm.controls;
      Object.keys(controls).forEach(groupName => {
        const group = controls[groupName];
        if (group.invalid) {
          Object.keys(group['controls']).forEach(fieldName => {
            const field = group.get(fieldName);
            if (field?.invalid && !excludedFields.includes(fieldName)) {
              invalidFields.push(fieldNamesMap[fieldName] || fieldName); // Use the friendly name if available
            }
          });
        }
      });
      // Display alert with invalid fields
      if (invalidFields.length > 0  && data.object != 'addressdetail' ) {
        Swal.fire({
          title:
            '<div class="popup-content"> <div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check"> Please enter all the required fields</div></div>',
          html: `<ol style="color: #ff0000;font-size: 12px;background: #ffd0d0;padding: 5px 10px 5px 20px;border-radius: 6px;    margin-bottom: 0;">${invalidFields
            .map(field => `<li style="text-align:left">${field}</li>`)
            .join('')}</ol>`,
          imageUrl: 'https://fortwayne.thesmartcity311.com/assets/images/fort-wayne-logo-seal-dark.svg',
          imageHeight: 45,
          icon: 'error',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: 'OK'
        });
      }
      else if (
        this.addressDetailsForm?.get('locationDtls.addressline1')?.value != '' &&
        (this.addressDetailsForm?.get('locationDtls.city')?.value == null || this.addressDetailsForm?.get('locationDtls.city')?.value == '') &&  data.object != 'addressdetail' && this.addressDetailsForm?.get('locationDtls.addresstype')?.value=="1362"
      ) {
        // Handle GIS verification
        console.log('in else');
        this.keyupenter();
      }
      else if ((this.addressDetailsForm?.get('locationDtls.addressline1')?.value != ''|| this.addressDetailsForm?.get('locationDtls.addressline2')?.value != '' ) &&
      (this.addressDetailsForm?.get('locationDtls.city')?.value == null || this.addressDetailsForm?.get('locationDtls.city')?.value == '') &&  data.object != 'addressdetail' &&this.addressDetailsForm?.get('locationDtls.addresstype')?.value == "1363")
      {
        this.onSearchIntersection();
      }
    }
    else if (
      this.addressDetailsForm?.get('locationDtls.addressline1')?.value != '' &&
      (this.addressDetailsForm?.get('locationDtls.city')?.value == null || this.addressDetailsForm?.get('locationDtls.city')?.value == '') && this.addressDetailsForm.valid && data.object != 'addressdetail'&& this.addressDetailsForm?.get('locationDtls.addresstype')?.value == "1362"
    ) {
      // Handle GIS verification
      console.log('in else');
      this.keyupenter();
    }
    else if ((this.addressDetailsForm?.get('locationDtls.addressline1')?.value != ''|| this.addressDetailsForm?.get('locationDtls.addressline2')?.value != '' ) &&
    (this.addressDetailsForm?.get('locationDtls.city')?.value == null || this.addressDetailsForm?.get('locationDtls.city')?.value == '')&& this.addressDetailsForm.valid &&  data.object != 'addressdetail' &&this.addressDetailsForm?.get('locationDtls.addresstype')?.value == "1363")
    {
      this.onSearchIntersection();
    }
    else if (this.addressDetailsForm.valid || data.object == 'addressdetail') {
      const locationDtlsGroup = this.addressDetailsForm.get('locationDtls') as FormGroup;
      this.agentscriptservice.updateOrInsertArray(this.tab_title,'addaddressdetailscheckbox',this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox']).value?1:0)
      locationDtlsGroup.removeControl('addaddressdetailscheckbox');
      console.log(this.addressDetailsForm.value.contactDtls);
      console.log(this.addressDetailsForm.value.locationDtls);
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.value.contactDtls);
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.value.locationDtls);

      // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

      // 
      var addressdetailform = this.agentscriptservice.fetchData(this.tab_title, 'addressdetailform')
      console.log(addressdetailform)
      var editedfieldss='' 
      console.log(editedfieldss)
      console.log(this.addressDetailsForm)
      if (addressdetailform != 0) {

        // addressdetailform.forEach((item: any) => {
        //   if (item && item.customProperty == 'disable')
        //   {
        //     console.log(item)
        //     const addressfieldvalue=this.addressDetailsForm.get(['locationDtls', item.name]).value
        //     if (addressfieldvalue && addressfieldvalue !== '' && addressfieldvalue !== "''") {
        //       // editedfieldss.push({ 'name': item.name, 'value': this.addressDetailsForm.get(['locationDtls', item.name]).value })
        //       editedfieldss += `${item.name}: ${addressfieldvalue},`;
        //     }
        //   }
        // })
        // editedfieldss = editedfieldss.replace(/, $/, '');
        // console.log(editedfieldss)

        editedfieldss = addressdetailform
          .filter((item: any) => item && item.customProperty === 'disable') // Only take disabled fields
          .map((item: any) => {
            const addressfieldvalue = this.addressDetailsForm.get(['locationDtls', item.name])?.value?.trim();

            if (addressfieldvalue && addressfieldvalue !== '' && addressfieldvalue !== "''") {
              // return `${item.name}: ${addressfieldvalue}`; // Return formatted string
              const formattedValue = this.getfieldvalue(item.name, addressfieldvalue);
              if (formattedValue) {
                return `${item.name}: ${formattedValue.value}`;
              }
              return `${item.name}: ${addressfieldvalue}`;
            }
            return null; // Remove empty values
          })
          .filter(Boolean) // Remove null/undefined values
          .join(', '); // Join without trailing comma

        console.log(editedfieldss);
        
      }


      this.serviceee = [];
      console.log(data);
      // this.serviceee=data;
      this.serviceee = data;
      this.serviceee = this.agentscriptservice.fetchData(this.tab_title, 'casetypedata');
      console.log(this.serviceee);
      console.log(editedfieldss);
      this.serviceee.serviceDetails['contactDtls'] = this.agentscriptservice.fetchData(this.tab_title, 'contactdata');
      // this.serviceee.serviceDetails['locationDtls'] = this.addressDetailsForm.value.locationDtls;
      this.serviceee.serviceDetails['locationDtls'] = {
        ...this.addressDetailsForm.value.locationDtls,
        ...{'manuallyoverridden': editedfieldss.length > 0},
        ...{'manuallyoverriddenfields':editedfieldss},
        ...(this.GISERROR?{'gischeck':true}:{}),
        ...(this.invalidaddress ? { invalidaddress: true } : {})
      };
      console.log(this.serviceee);
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'serviceTypeInfo', this.serviceee);
      console.log(data);
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'modifiedfromanonymouscontact', 1);
      // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

      // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

      this.serviceTypeDetailsOutputEvent.emit(data);

      
    }
    else {
      this.formsubmitted = true;
    }
  }
  // gotoNext(data: any, type: any) {
  //   console.log(data)
  //       this.serviceee=data;

  //       this.serviceee.serviceDetails['serviceDetails']=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
  //   // this.serviceee=data;
  //   this.serviceee.serviceDetails['contactDtls']= this.addressDetailsForm.value.contactDtls
  //   this.serviceee.serviceDetails['locationDtls']=this.addressDetailsForm.value.locationDtls;
  //   console.log( this.serviceee)
  //   // this.serviceee.serviceDetails["contactDtls"] = this.addressDetailsForm.value.contactDtls
  //   // this.serviceee.serviceDetails["locationDtls"] = this.addressDetailsForm.value.locationDtls;
  //   // serviceee.serviceDetails
  //   // console.log(this.serviceTypeInfo.serviceDetails)
  //   // this.serviceTypeInfo.serviceDetails["contactDtls"] = this.addressDetailsForm.value.contactDtls;
  //   // this.serviceTypeInfo.serviceDetails["locationDtls"] = this.addressDetailsForm.value.locationDtls;
  //   // this.serviceTypeInfo.serviceDetails['nearbyIncidents'] = this.nearbyIncidents
  //   // console.log(this.serviceee)
  //   // data.serviceDetails = this.serviceee
  //   // console.log(data)
  //   this.agentscriptservice.updateOrInsertArray(this.tab_title,'serviceTypeInfo',this.serviceee)
  //   this.serviceTypeDetailsOutputEvent.emit(data);
  // }

  // AssociationNext(data: any, type: any) {
  //   console.log(this.serviceTypeInfo.serviceDetails)
  //   data.serviceDetails = {
  //         "casetypeid": 296,
  //         "qid": 21,
  //         "division": {
  //           "id": 883,
  //           "name": "Information Ticket"
  //         },
  //         "department": {
  //           "id": 295,
  //           "name": "Information Ticket"
  //         },
  //         "imageUrl": "../../assets/images/information-ticket.png",
  //         "filename": "informationticket.json",
  //         "content": "Information Ticket",
  //         "estimatetime":"30 Days",
  //         "colwidth":"2"
  //   }
  //   data.serviceDetails["contactDtls"] = this.addressDetailsForm.value.contactDtls;
  //   data.serviceDetails["locationDtls"] = this.addressDetailsForm.value.locationDtls;
  //   this.serviceTypeInfo.serviceDetails['nearbyIncidents']=this.nearbyIncidents

  //   console.log(data)
  //   this.serviceTypeDetailsOutputEvent.emit(data);
  // }
  @ViewChild('sameAsServiceAddressCheckbox') sameAsServiceAddressCheckbox: any;
  clearmap() {
    if (this.sameAsServiceAddressCheckbox) {
      this.sameAsServiceAddressCheckbox.nativeElement.checked = false;
    }
    this.entiredata = [];
    this.EsriMapComponent.addressvalue = ''
    this.EsriMapComponent.initializeMap()
  }
  clearForm() {

    // this.EsriMapComponent.addressvalue=''
    // this.EsriMapComponent.initializeMap()
    this.garbagecollectionday='';
    this.isGisVerified = false
    this.nearbyIncidents = []
    this.alertIncidents = []
    this.addressDetailsForm.get('locationDtls')?.reset();

    // this.addressDetailsForm.reset();
    this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362");
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

    // this.isLocationSearch =true;
    console.log(this.addressDetailsForm.get(['contactDtls']).value)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', [])

    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

  }
  isAddresstypeChange() {
    this.isLocationSearch = true;
    this.assignentireaddress = '';
    this.loadMap_button = true
    this.nearbyIncidents = []
    this.alertIncidents = []
    this.entiredata = [];
    this.garbagecollectionday='';
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', [])

    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

    const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
    if (issame) {
      (issame as HTMLInputElement).checked = false;
    }
    // this.agentscriptservice.emitAddress('')
    this.EsriMapComponent.searchLocation = ''
    this.EsriMapComponent.addressvalue = ''
    const addressline1Control = this.addressDetailsForm.get(['locationDtls', 'addressline1']);
    // console.log(addressline1Control.value == null || addressline1Control.value == '' || addressline1Control.value == undefined)
    if (!(addressline1Control.value == null || addressline1Control.value == '' || addressline1Control.value == undefined)) {

      this.EsriMapComponent.initializeMap();
    }
    this.isGisVerified = false;

    // this.isLocationSearch = true;
    setTimeout(() => {
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.patchValue("");
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.patchValue("")
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
      this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")


      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

      console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))

    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

      // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

      // this.addressDetailsForm.get(['locationDtls', 'sla'])?.setValue("")
    }, 200)
    this.custompropertyAssign()
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', 0);
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetailscheckbox', 0)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', 0)
    this.agentscriptservice.updateOrInsertArray(this.tab_title,'locationdata',0)
  }
  searchLocationEvent(data: any) {
    console.log(data);
    localStorage.setItem("locationInfo", JSON.stringify(data));
    if (data.address_t == "SINGLE_LINE") {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362");
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue("");
    } else {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363");
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(data.address2);
    }
    this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(data.address);
    //console.log(this.addressDetailsForm.get(['locationDtls','addressline1'])?.setValue(data.address))
    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(data.city);
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(data.state);
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(data.postalcode);
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(data.lon);
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(data.lat);
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue('191');
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue('193');
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("Commercial");
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue('1360');
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue('02-12-02-432-001.000-074');
    // this.addressDetailsForm.get(['locationDtls','sla'])?.setValue('');

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

  }
  searchAddress: any;
  searchAddress1: string;

  // @Output() searchAddressClicked = new EventEmitter<string>();

  // onSearchClick() {
  //   console.log("xfgvbn")
  //   // Emit the search address when the search button is clicked
  //   this.searchAddressClicked.emit(this.searchAddress);
  // }

  // dropdownOpen: boolean = false;
  // openDropdown(event: any) {
  //   if (event.keyCode !== 27) { // Check if the key is not the escape key
  //       this.dropdownOpen = true;
  //   }
  // }
  showview(e: any) {
    console.log("3d view clicked")
  }
  emptyintersection() {
    this.isLocationSearch =true;
    const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
    if (addline1 == '' && addline2 == '') {
      this.clearForm()
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363")
    }

  }
  clearintersectionaddress()
  {
    this.isGisVerified = false;
    this.invalidaddress = false;
    this.custompropertyAssign()

    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")
  }
  onSearchIntersection() {
    this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(false);
    this.isLocationSearch=true
    this.entiredata = [];

    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
      this.assignentireaddress=this.addressDetailsForm?.get('locationDtls.addressline1')?.value

    if (this.addressDetailsForm?.get('locationDtls.addressline1')?.value.includes('&')) {
      this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value, 'Intersection')
    }
    else if (addline2 != null && addline2 != '' && addline2 != undefined) {
      this.assignentireaddress=(this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value)
      this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value, 'Intersection')
    }
    else {
      console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)
      this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value, 'Address')
    }
    console.log(this.assignentireaddress)
  }

  // openswal()
  // {
  //   // Swal.fire({
  //   //   title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg" alt="Selected Image" class="selected-image"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Given address is either not in Fort Wayne City limits or not a valid address<br><span>Do you want to add this address?</span></div></div>',
  //   //   icon: 'error',
  //   //   showCloseButton: true,
  //   //   showCancelButton: false,
  //   //   focusConfirm: false,
  //   //   confirmButtonText: 'OK',
  //   //   cancelButtonText: 'Cancel',
  //   //   // input: 'text',
  //   //   // inputPlaceholder: 'Enter your address here',
  //   //   html: `
  //   //     <input type="checkbox" id="addressCheckbox">
  //   //     <label for="myCheckbox">Check this box</label>
  //   //   `,
  //   //   // preConfirm: (value) => {
  //   //   //   if (!value) {
  //   //   //     Swal.showValidationMessage('You need to write something!');
  //   //   //   }
  //   //   // }
  //   // }).then((result) => {
  //   //   // const userInput = Swal.getInput().value;
  //   //   const checkboxValue = document.querySelector('input[type="checkbox"][id="addressCheckbox"]') as HTMLInputElement
  //   //   const checkValue = checkboxValue.checked;
  //   //   // console.log(userInput,checkboxValue,checkValue)
  //   //   // if (result.isConfirmed) {
  //   //   //   console.log('User input:', userInput);
  //   //   //   console.log('Checkbox is checked:', checkboxValue);
  //   //   //   // Handle the input value and checkbox value as needed
  //   //   // } else if (result.dismiss === Swal.DismissReason.close) {
  //   //   //   console.log('Popup closed, user input:', userInput);
  //   //   //   console.log('Checkbox is checked:', checkboxValue);
  //   //   //   // Handle the input value and checkbox value as needed
  //   //   // }
  //   //   if(checkValue)
  //   //     {
  //   //       alert("checked")
  //   //     }
  //   //     else{
  //   //       alert("unchecked")
  //   //     }
  //   // });

  //   Swal.fire({
  //     title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg" alt="Selected Image" class="selected-image"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Given address is either not in Fort Wayne City limits or not a valid address<br><span>Do you want to add this address?</span></div></div>',
  //     icon: 'error',
  //     showCloseButton: true,
  //     showCancelButton: true,
  //     focusConfirm: false,
  //     confirmButtonText: 'OK',
  //     cancelButtonText: 'Cancel',
  //     html: `
  //       <input type="checkbox" id="addressCheckbox">
  //       <label for="myCheckbox">Check this box</label>
  //     `,

  //   }).then((result) => {
  //     console.log(result)
  //     // console.log(result.value)
  //     if(result.value)
  //       {
  //         console.log("haha")
  //       }
  //       else{
  //         console.log("hehe")
  //       }
  //     // result.map((key: string)=> {
  //     //   console.log(key)
  //     // })
  //     // if (result) {
  //     //   const key = result[0];
  //     //   console.log(result.key);
  //     // } else {
  //     //   console.log("fail")
  //     //   return '';
  //     // }


  //     const checkboxValue = document.querySelector('input[type="checkbox"][id="addressCheckbox"]') as HTMLInputElement
  //     const checkValue = checkboxValue.checked;

  //     if (checkValue) {
  //       // alert("checked")
  //       this.addaddressdetails=true
  //       // this.addressDetailsForm.get(['locationDtls', 'addressline1'])
  //     }
  //     else {
  //       this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
  //       this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
  //     }
  //   });
  // }
  fetchaddressdetails: any;
  addaddressdetails: boolean
  showcheckbox: boolean;
  garbageaddress:any;
  garbagezip:any;
  invalidaddress: boolean;
  GISERROR:boolean=false
  // Within Limits picklist value 192 = Outside Fort Wayne, treated like an address outside city limits
  outsidecitylimits: string = '192';
  isOutsideCityLimits(data: any) {
    return String(data?.address_details?.within_limits ?? '') == this.outsidecitylimits;
  }
  loadAllData(item: any, type: any) {
    this.highlightedIndex=-1
    this.GISERROR=false
    this.agentscriptservice.updateOrInsertArray(this.tab_title,'giserror',0);
    console.log("loadMap", this.assignentireaddress)
    console.log(type);
    let casetypeid = this.componentData.serviceDetails.casetypeid;
    var streetAddress = this.assignentireaddress;
    console.log(streetAddress)
    console.log(/^\d/.test(streetAddress))
    if (/^\d/.test(streetAddress) || type.toLowerCase() == 'intersection') {
      streetAddress=this.assignentireaddress.split(',')[0].trim();
    } 
    else {
      let parts = this.assignentireaddress.split(',');
      streetAddress = parts.length > 1 ? parts[1].trim() : "";
    }
    console.log(streetAddress)
    this.agentscriptservice.fetchaddressdetails(streetAddress, type, casetypeid).subscribe((data: any) => {
      this.fetchaddressdetails = data
      console.log(this.fetchaddressdetails)
      this.garbageaddress = this.fetchaddressdetails.returned_address;
      // this.garbagezip=this.fetchaddressdetails.personal_data.mailing_zip;
      console.log(this.invalidaddresspopup)
        if(data.hasOwnProperty('error'))
          {
            Swal.fire({
              title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Currently we are unable to retrieve some information from the GIS. Add the missing fields if required</div></div>',
              icon: 'error',
              imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
            imageHeight: 45,
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              
            }).then((result) => {
              if (result.value) {
    
                (this.addressDetailsForm.get(['locationDtls', 'postalcode']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'withinlimits']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'jurisdiction']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'zoning']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'recycleweek']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'collectionday']) as any).customProperty = 'disable';
                (this.addressDetailsForm.get(['locationDtls', 'parcelnumber']) as any).customProperty = 'disable';
      
                const locationdtls = this.addressDetailsForm.get(['locationDtls'])
                if (locationdtls instanceof FormGroup) {
                  console.log(locationdtls.controls);
      
      
                  let result: any[] = [];
                  Object.keys(locationdtls.controls).forEach(key => {
                    const control = locationdtls.get(key);
      
                    // Check for custom property
                    if ((control as any).customProperty) {
                      result.push({
                        name: key,
                        value: control.value,
                        customProperty: (control as any).customProperty
                      });
                    }
      
                  });
                  this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', result)
                }
                this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('Fort Wayne')
                this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")
                this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
                this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue('');
                this.removeValidatorsFromLocationDtls()
                this.isLocationSearch=false
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', [])
                this.GISERROR = true
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', 1);
              }
              else {
                this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
                this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
              }
    
            });
          }
      else if ((data?.status == "NOTOK" || this.isOutsideCityLimits(data)) && this.invalidaddresspopup!='addressdetail') {
        console.log(data)
        this.activeinfobutton=false
        // alert('Given address is either not in Fort Wayne City limits or not a valid address')
        Swal.fire({
          title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Given address is either not in Fort Wayne City limits or not a valid address</div></div>',
          icon: 'error',
          imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
        imageHeight: 45,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          html: `
          <div class="form-check">
          <input class="form-check-input" type="checkbox" id="addressCheckbox">
          <label class="form-check-label ms-2" for="addressCheckbox" >Add this address and proceed. </label>
          </div>
          `,

        }).then((result) => {

          

          console.log(result)
          // console.log(result.value)
          const checkboxValue = document.querySelector('input[type="checkbox"][id="addressCheckbox"]') as HTMLInputElement
          const checkValue = checkboxValue.checked;
          console.log(checkValue)
          this.garbagecollectionday='';
          if (result.value) {


            if (checkValue) {

              (this.addressDetailsForm.get(['locationDtls', 'postalcode']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'withinlimits']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'jurisdiction']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'zoning']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'recycleweek']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'collectionday']) as any).customProperty = 'disable';
          (this.addressDetailsForm.get(['locationDtls', 'parcelnumber']) as any).customProperty = 'disable';

          const locationdtls = this.addressDetailsForm.get(['locationDtls'])
          if (locationdtls instanceof FormGroup) {
            console.log(locationdtls.controls);


            let result: any[] = [];
            Object.keys(locationdtls.controls).forEach(key => {
              const control = locationdtls.get(key);

              // Check for custom property
              if ((control as any).customProperty) {
                result.push({
                  name: key,
                  value: control.value,
                  customProperty: (control as any).customProperty
                });
              }

            });
            // return result;
            this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', 0)
            this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', result)
          }

              // alert("checked")
              // this.addaddressdetails=true
              this.showcheckbox = true
              this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(true);
              const addaddress = document.querySelector('input[type="checkbox"][id="addaddressdetailscheckbox"]');
              console.log(addaddress)
              if (addaddress) {
                (addaddress as HTMLInputElement).checked = true;
                this.addaddressdetails = true
              }
              this.garbagecollectionday=streetAddress;
              this.addaddressdetails = true;
              console.log(this.addressDetailsForm.get(['locationDtls', 'addressline1']).value)
              // this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('hehe')
              console.log(this.addressDetailsForm.get(['locationDtls', 'addressline1']).value)
              // this.addressDetailsForm.get(['locationDtls', 'addressline1'])
              if (this.isOutsideCityLimits(data)) {
                // GIS found the address but it sits outside Fort Wayne (Within Limits = 192).
                // Keep the details it returned instead of blanking the location fields.
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', data)
                if (this.fetchaddressdetails?.address_type != null && this.fetchaddressdetails?.address_type != '' && this.fetchaddressdetails?.address_type != undefined) {
                  this.isGisVerified = true
                }
                this.receiveData({
                  msr_addresstype: this.fetchaddressdetails?.address_type,
                  msr_serviceaddress: this.fetchaddressdetails?.returned_address,
                  msr_city: 'IN',
                  msr_state: 'FORT WAYNE',
                  msr_zip: this.fetchaddressdetails?.address_details?.zip,
                  msr_withinlimits: this.fetchaddressdetails?.address_details?.within_limits,
                  msr_recycleweek: this.fetchaddressdetails?.address_details?.recycle_week_ID,
                  msr_collectionday: this.fetchaddressdetails?.address_details?.collection_day,
                  msr_jurisdiction: this.fetchaddressdetails?.address_details?.jurisdiction,
                  msr_next_collection_day: this.fetchaddressdetails?.address_details?.next_collection_day,
                  msr_zoning: this.fetchaddressdetails?.address_details?.zoning_id,
                  msr_lat: this.fetchaddressdetails?.lat,
                  msr_lng: this.fetchaddressdetails?.lng,
                  msr_parcelnumber: this.fetchaddressdetails?.personal_data?.parcel_number,
                  msr_nearbyIncidents: this.fetchaddressdetails?.nearby_incidents,
                  msr_alertIncidents: this.fetchaddressdetails?.nearby_alert_incidents
                })
                this.updateValidators();
                this.isLocationSearch=false
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetails', 1)
                this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)
                this.invalidaddress = true;
              }
              else {
              this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('Fort Wayne')
              this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")
              this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
              this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue('');
              this.updateValidators();
              this.isLocationSearch=false
              this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetails', 1)
              this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)
              this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', [])
              this.invalidaddress = true;
              }
              // this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', 1);
              // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

              // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

            }
            else {

              // this.addaddressdetails=false
              this.showcheckbox = false
              this.isLocationSearch =true;
              this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
              this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
            }


          }
          else {
            this.custompropertyAssign()
            this.isLocationSearch =true;
            this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
            this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
          }
          // result.map((key: string)=> {
          //   console.log(key)
          // })
          // if (result) {
          //   const key = result[0];
          //   console.log(result.key);
          // } else {
          //   console.log("fail")
          //   return '';
          // }



        });

        // this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
        // this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')

        const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
        if (issame) {
          (issame as HTMLInputElement).checked = false;
          this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(false);

        }
        if (this.fetchaddressdetails.hasOwnProperty('error') && this.fetchaddressdetails.error != null) {
            this.GISERROR = true
        }
      }
      else {
        if ((this.fetchaddressdetails.address_details.hasOwnProperty('error') && this.fetchaddressdetails.address_details.error != null) || (this.fetchaddressdetails.personal_data.hasOwnProperty('error') && this.fetchaddressdetails.personal_data.error != null)) {
          
          Swal.fire({
            title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">Currently we are unable to retrieve some information from the GIS. Add the missing fields if required</div></div>',
            icon: 'error',
            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
          imageHeight: 45,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            // html: `
            // <div class="form-check">
            // <label class="form-check-label ms-2" for="continue" >Do you wish to continue?</label>
            // </div>
            // `,
  
          }).then((result) => {
            if (result.value) {


              this.GISERROR = true
              this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', 1);
              this.removeValidatorsFromLocationDtls()

              this.activeinfobutton = true
              console.log(this.fetchaddressdetails)

              this.agentscriptservice.locationcoordinates = this.fetchaddressdetails

              const coords = {
                msr_addresstype: this.fetchaddressdetails?.address_type,
                msr_serviceaddress: this.fetchaddressdetails?.returned_address,
                // msr_city: this.fetchaddressdetails?.personal_data?.property_address_city,
                // msr_state: this.fetchaddressdetails?.personal_data?.mailing_state,
                msr_city: 'IN',
                msr_state: 'FORT WAYNE',
                msr_zip: this.fetchaddressdetails?.address_details?.zip,
                msr_withinlimits: this.fetchaddressdetails?.address_details?.within_limits,
                msr_recycleweek: this.fetchaddressdetails?.address_details?.recycle_week_ID,
                msr_collectionday: this.fetchaddressdetails?.address_details?.collection_day,
                msr_jurisdiction: this.fetchaddressdetails?.address_details?.jurisdiction,
                msr_next_collection_day: this.fetchaddressdetails?.address_details?.next_collection_day,
                msr_zoning: this.fetchaddressdetails?.address_details?.zoning_id,
                msr_lat: this.fetchaddressdetails?.lat,
                msr_lng: this.fetchaddressdetails?.lng,
                // msr_lat: (this.fetchaddressdetails?.lat=="41.078092262155096")?"41.0786357":this.fetchaddressdetails?.lat,
                // msr_lng: (this.fetchaddressdetails?.lng=="-85.14117085258414")?"-85.1370722":this.fetchaddressdetails?.lng,
                msr_parcelnumber: this.fetchaddressdetails?.personal_data?.parcel_number,
                msr_nearbyIncidents: this.fetchaddressdetails?.nearby_incidents,
                msr_alertIncidents: this.fetchaddressdetails?.nearby_alert_incidents
                // msr_parcelnumber: this.fetchaddressdetails?.personal_data.parcel_number,
              };

              this.agentscriptservice.updateOrInsertArray(this.tab_title, "mapdata", data)

              // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

              console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))

              console.log(coords)

              if (this.fetchaddressdetails?.address_type != null && this.fetchaddressdetails?.address_type != '' && this.fetchaddressdetails?.address_type != undefined) {
                this.isGisVerified = true
              }

              // this.childComponentValue.emit(coords);

              this.receiveData(coords)
              console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))
              // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

              // this.loadmapping(response)

            }
            else {
              this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
              this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')
            }

          });
        }

        else{
    this.activeinfobutton=true
        console.log(this.fetchaddressdetails)

        this.agentscriptservice.locationcoordinates = this.fetchaddressdetails

        const coords = {
          msr_addresstype: this.fetchaddressdetails?.address_type,
          msr_serviceaddress: this.fetchaddressdetails?.returned_address,
          // msr_city: this.fetchaddressdetails?.personal_data?.property_address_city,
          // msr_state: this.fetchaddressdetails?.personal_data?.mailing_state,
          msr_city: 'IN',
          msr_state: 'FORT WAYNE',
          msr_zip: this.fetchaddressdetails?.address_details?.zip,
          msr_withinlimits: this.fetchaddressdetails?.address_details?.within_limits,
          msr_recycleweek: this.fetchaddressdetails?.address_details?.recycle_week_ID,
          msr_collectionday: this.fetchaddressdetails?.address_details?.collection_day,
          msr_jurisdiction: this.fetchaddressdetails?.address_details?.jurisdiction,
          msr_next_collection_day: this.fetchaddressdetails?.address_details?.next_collection_day,
          msr_zoning: this.fetchaddressdetails?.address_details?.zoning_id,
          msr_lat: this.fetchaddressdetails?.lat,
          msr_lng: this.fetchaddressdetails?.lng,
          // msr_lat: (this.fetchaddressdetails?.lat=="41.078092262155096")?"41.0786357":this.fetchaddressdetails?.lat,
          // msr_lng: (this.fetchaddressdetails?.lng=="-85.14117085258414")?"-85.1370722":this.fetchaddressdetails?.lng,
          msr_parcelnumber: this.fetchaddressdetails?.personal_data?.parcel_number,
          msr_nearbyIncidents: this.fetchaddressdetails?.nearby_incidents,
          msr_alertIncidents: this.fetchaddressdetails?.nearby_alert_incidents
          // msr_parcelnumber: this.fetchaddressdetails?.personal_data.parcel_number,
        };

        this.agentscriptservice.updateOrInsertArray(this.tab_title, "mapdata", data)

        // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

        console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))

        console.log(coords)

        if (this.fetchaddressdetails?.address_type != null && this.fetchaddressdetails?.address_type != '' && this.fetchaddressdetails?.address_type != undefined) {
          this.isGisVerified = true
        }

        // this.childComponentValue.emit(coords);

        this.receiveData(coords)
        console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))
    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

        // this.loadmapping(response)
      }

    }
    })
  }
  updateValidators() {
    const controls = [
      'city', 'state', 'latitude', 'longitude', 'postalcode', 'withinlimits', 'jurisdiction', 'zoning', 'recycleweek'
    ];

    controls.forEach(controlName => {
      const control = this.addressDetailsForm.get(['locationDtls', controlName]);
      console.log(this.showcheckbox)
      if (this.showcheckbox) {
        control?.clearValidators();
      } else {
        control?.setValidators(Validators.required);
      }
      control?.updateValueAndValidity();
    });
  }
  // onSearchAddress() {
  //   console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)
  //   this.onLoadMap({ text: this.addressDetailsForm?.get('locationDtls.addressline1')?.value })
  // }
  showbutton: boolean = false;
  LoadMap() {
    console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)
    console.log(this.addressDetailsForm?.get('locationDtls.addaddressdetailscheckbox')?.value)
    this.showbutton = true;
    console.log("clicked on loadmap")
    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
    const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    if (addline2 != null && addline2 != '' && addline2 != undefined && !this.addressDetailsForm?.get('locationDtls.addaddressdetailscheckbox')?.value) {
      this.onLoadMap({ text: this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value })
    }
    else if (addline1 != null && addline1 != '' && addline1 != undefined && !this.addressDetailsForm?.get('locationDtls.addaddressdetailscheckbox')?.value) {
      this.onLoadMap({ text: this.addressDetailsForm?.get('locationDtls.addressline1')?.value })
    }
    else {
      this.EsriMapComponent.addressvalue = ''
      this.EsriMapComponent.initializeMap()
    }
  }

  searchelement: any
  onLoadMap(item: any) {
    // alert('')
    // this.nearbyIncidents=[]

    //   // this.isLocationSearch = true;
    // this.isGisVerified = true;
    //   this.searchAddress=this.addressDetailsForm.value.locationDtls.addressline1;
    //   this.searchAddress1=this.addressDetailsForm.value.locationDtls.addressline2;
    //   console.log(this.addressDetailsForm.value.locationDtls.addresstype)
    //  if(this.addressDetailsForm.value.locationDtls.addresstype == "1362"){
    //    this.agentscriptservice.emitAddress(this.searchAddress);
    //   }else{
    //     var concatenateAddress= this.searchAddress + ' & ' + this.searchAddress1
    //     this.agentscriptservice.emitAddress(concatenateAddress);

    //   }
    this.isLocationSearch = true;
    this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(false);
    // this.isGisVerified = true;
    this.searchAddress = this.addressDetailsForm.value.locationDtls.addressline1;
    this.searchAddress1 = this.addressDetailsForm.value.locationDtls.addressline2;
    console.log(this.addressDetailsForm.value.locationDtls.addresstype)
    console.log(this.searchAddress)
    // this.agentscriptservice.addresstobesearched = item
    this.agentscriptservice.locationcoordinates = this.fetchaddressdetails
    // this.
    console.log(item)
    console.log(item.text)
    if (item.text != null && item.text != '' && item.text != undefined) {
      // this.agentscriptservice.emitAddress(item.text);
      this.agentscriptservice.emitAddress({ address: item.text, tabId: this.tab_title });
    }
    else {
      this.EsriMapComponent.addressvalue = ''
      // this.EsriMapComponent.searchLocation=''
      // alert("empty")
      this.EsriMapComponent.initializeMap()

    }

    this.searchelement = item.text;

    this.entiredata = []

    this.showEsri = true;

    // $('#esrimap').trigger('click')
    // this.GoogleMapComponent.showStreetView()

  }
  showEsri: boolean = true;
  showGoogle: boolean = false;

  showEsriMap(event: MouseEvent) {
    // this.class1Active = !this.class1Active;

    console.log(this.searchAddress)
    console.log(this.searchelement)
    this.showEsri = true;

    // this.agentscriptservice.emitAddress(this.searchelement);

    event.preventDefault();

  }

  // Method to show Google Map
  showGoogleMap(event: MouseEvent) {

    this.showEsri = false;

    this.agentscriptservice.searchAddress = this.searchAddress;
    console.log(this.agentscriptservice.locationcoordinates)
    event.preventDefault(); // Prevent default behavior of the button
    // const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;


    // this.GoogleMapComponent.searchLocation=addline1
    // this.GoogleMapComponent.latitude=this.fetchaddressdetails.lat
    // this.GoogleMapComponent.longitude=this.fetchaddressdetails.lng
    this.GoogleMapComponent.showStreetView()

  }


  showDropdown: boolean = false;
  addressSuggestions: any;

  // suggestionSearch(event:any){
  //   console.log(event.term);
  //    this.performAddressSearch(event.term);
  // }
  addressvalue: any
  suggestionSearch() {
    this.highlightedIndex=-1
    this.GISERROR=false
    this.invalidaddress = false;
    this.custompropertyAssign()

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'giserror', 0);
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addaddressdetailscheckbox', 0)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'addressdetailform', 0)
    this.agentscriptservice.updateOrInsertArray(this.tab_title,'locationdata',0)

    // setTimeout(()=>
    // {

    // debugger;
    this.isGisVerified=false
    this.isLocationSearch =true;
    this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(false);
    $('#spinner').addClass('hideload');
    console.log($('#spinner').addClass('hideload'))
    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")
    console.log(this.addressvalue);
    if (this.addressDetailsForm?.get('locationDtls.addresstype')?.value == '1362') {
      console.log("1 addressline")
      this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    }
    else {
      console.log("2 addresslines")
      this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value + '%26' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value
    }
    console.log(this.addressvalue)
    this.performAddressSearch(this.addressvalue);

    if (this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value == '') {
      this.entiredata = [];
      this.garbagecollectionday='';
    }

    // },3000);
  }
  // searchAddress: any;

  onDropdownChange() {
    console.log(this.addressDetailsForm.get(['locationDtls', 'addressline1']))
    this.searchAddress = this.addressDetailsForm.get(['locationDtls', 'addressline1']);
    //  this.onSearch();
  }

  // onDropdownChange(selectedValue: string) {
  //   this.searchAddress = selectedValue;
  //  this.onSearch();
  // }
  isClearable(): boolean {
    return !!this.searchAddress;
  }

  keyupenter() {
    this.GISERROR=false
    this.isLocationSearch =true;
    this.addressDetailsForm.get(['locationDtls', 'addaddressdetailscheckbox'])?.setValue(false);
    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
    const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    console.log(addline1)
    console.log(addline2)
    if (addline2 != null && addline2 != '' && addline2 != undefined) {
      console.log("intersection")
      this.assignaddress(this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value)
    }
    else if (addline1 != null && addline1 != '' && addline1 != undefined) {
      console.log("address")
      this.assignaddress(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)
    }
  }
  assignentireaddress: any
  activeinfobutton:any
  assignaddress(item: any) {
    this.assignentireaddress = item
    this.clearaddaddressdetails()
    this.showEsri = true
    this.isGisVerified = false
    this.loadMap_button = true
    console.log("in assign address" + item)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)

    this.EsriMapComponent.addressvalue = ''
    this.EsriMapComponent.initializeMap()
    // this.addressDetailsForm.get('locationDtls')?.reset();
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    // this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue("")
    // this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")



    this.entiredata = []
    this.nearbyIncidents = []
    this.alertIncidents = []
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)

    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

    console.log(item)
    // this.onSearch(item);
    // var streetAddress = item.split(',')[0].trim();
    var streetAddress = item
    console.log(streetAddress);
    this.garbagecollectionday=streetAddress;
    this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(streetAddress)

    // this.
    // this.loadAllData(item,'Address')
    this.onSearchIntersection()

    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})


  }
  entiredata: any;
  async performAddressSearch(searchTerm: any) {
    console.log(searchTerm)
    //  setTimeout(()=>{
    if (!(searchTerm == null || searchTerm == '' || searchTerm == undefined)) {
      try {
        // Trim the search term to remove any leading or trailing spaces
        // const trimmedSearchTerm = searchTerm.trim();
        const trimmedSearchTerm = searchTerm?.trim();

        // console.log(trimmedSearchTerm);

        if (trimmedSearchTerm !== '') { // Check if search term is not empty
          // $('#spinner').addClass('hideload');
          this.agentscriptservice.mapsuggestions(trimmedSearchTerm).subscribe((response: any) => {
            // debugger;
            // setTimeout(()=>{
            // $('#spinner').addClass('hideload');

            // },200)

            // console.log(response.suggestions);
            this.entiredata = response.suggestions;
            const oldLength = this.entiredata.length;

            if (this.entiredata.length !== oldLength) {
              this.highlightedIndex = -1;
            }
            const hasMainAddress = this.entiredata.some(
              (item: { text: string }) => item.text.toLowerCase().includes("200 e berry st")
            );

            if (hasMainAddress) {
              // Filter out "200E E Berry St" from the array
              this.entiredata = this.entiredata.filter(
                (item: { text: string }) => !item.text.toLowerCase().includes("200e e berry st")
              );
            }
            this.addressSuggestions = response.suggestions.map((suggestion: { text: any; }) => suggestion.text);

            console.log(this.entiredata);
            console.log(this.addressSuggestions)
            // console.log(this.addressSuggestions);
          });
        } else {
          // Clear suggestions if search term is empty
          this.addressSuggestions = [];
        }
      } catch (error) {
        console.error('Error fetching address suggestions:', error);
      }

    }
    //  },200)
    else {
      this.entiredata = []
      console.log("is empty")
      this.clearForm()
    }
    // },2000)

  }
  searchAddress2: any;
  openActiveSR(item: any) {
    console.log(item)
    let d = { id: item.id, name: item.referenceNumber, type: 'object', entityName: 'Incident', department: item.department_name };
    console.log("activesrvalues", d);

    this.componentSelection.emit(d);
  }

  openAlertIncident(item:any)
  {
    console.log(item)
    this.agentscriptservice.updateOrInsertArray(item.referenceNumber,'scriptpayloaddata',item)

    // this.standardservice.SavetolocalStorage('tabdata',this.agentscriptservice.AlldataArray)

    // this.standardservice.SavetolocalStorage('addressdetails',{data:this.componentData,name:this.tab_title,tabdata:this.agentscriptservice.AlldataArray})

    let d = { id: item.id, name: item.referenceNumber, type: 'alertincident', entityName: 'opencreatedalert', department: item.department_name, src:"https://fortwayne-portal.thesmartcity311.com/assets/images/AlertIncidentActive.svg" };
    console.log("activesrvalues", d);
    this.componentSelection.emit(d);

  //   {
  //     "id": "alertincident2",
  //     "name": "Alert SR",
  //     "type": "alertincident",
  //     "entityName": "",
  //     "department": "",
  //     "src": "https://fortwayne-portal.thesmartcity311.com/assets/images/AlertIncidentActive.svg    ",
  //     "actiontype": "",
  //     "tabid": "240531-000003"
  // }
  }
}
